var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _circle, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetailers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#f3dbe3",
    vectorEffect: "non-scaling-stroke",
    d: "M22.65.21 1.73 14.68a1.01 1-17.2 0 0-.44.83q-.04 19.25-.16 38.46c-.02 1.9-1.66 4.43.1 6.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fbf4f4",
    vectorEffect: "non-scaling-stroke",
    d: "M1.23 60.08q.36 13.13.33 26.36-.01 3.64 2.31 7.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cbcbc9",
    vectorEffect: "non-scaling-stroke",
    d: "M3.87 94.26c1.13 1.42 1.91 3.39 3.15 4.33q2.63 1.99 6.95.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9da6a2",
    vectorEffect: "non-scaling-stroke",
    d: "m13.97 99.53.28 3.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b8c9c3",
    vectorEffect: "non-scaling-stroke",
    d: "M14.25 103.5v272"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b8aeab",
    vectorEffect: "non-scaling-stroke",
    d: "m14.25 375.5.29 9.85a1.07 1.07 0 0 1-.96 1.1l-10.97 1.13a.96.96 0 0 0-.85.77q-1.38 6.83 1.88 8.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e8eae7",
    vectorEffect: "non-scaling-stroke",
    d: "m3.64 396.55.97 5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f9f9f9",
    vectorEffect: "non-scaling-stroke",
    d: "m4.61 401.55.6 5.69q.05.51.46.81 2.96 2.17 3.88 2.67 19.3 10.39 38.14 21.59 2.14 1.27 2.87 2.05.31.33.75.45l1.72.47a2.05 1.97 75.3 0 1 .9.55q1.62 1.75 4.1 1.39a1.24 1.24 0 0 0 1.02-1.54c-.95-3.52 7.68-2.84 9.48-2.78 3.08.09 4.65.77 7.72-.65a1.47 1.47 0 0 1 .97-.08c2.63.7 4.22.89 7.02-.18 1.84-.7 11.66-2.43 11.86 1.24q.03.6.61.47l3.92-.84q.45-.1.89.03 1.46.43 2.88-.28.39-.19.82-.15 1.83.18 3.65.24c3.26.11 5.16-1.61 8.93-.46a1.37 1.32-47.6 0 0 .95-.06q4.11-1.84 8.66-1.07.41.07.68.39c1.1 1.28 8.01.03 9.23-.35q.47-.14.68-.6.82-1.77 3.03-1.75 3.24.03 7.01-.91.5-.12.98.09 2.34 1.04 4.89.73.52-.06.92-.39 1.83-1.46 4.19-.57a1.44 1.42-43.9 0 0 .97.01q4.3-1.48 8.85-1.36c2.16.06 3.94-1.1 6.29-1.16q11.49-.31 22.89-1.71c1.76-.22 3.79-.05 5.7-.28 1.55-.19 2.7-1.31 4.51-1.22q.46.02.88-.17c3.69-1.66 7.47-2.3 11.37-1 3.09 1.03 10.69-.83 9.67-5.52q-.11-.51-.54-.8-2.43-1.63-5.34-1.77-.19-.01-.25.17-.06.17-.11.34a.17.17 0 0 1-.33 0q-.53-1.58-2.07-2.15-.44-.16-.66-.57-.84-1.56-.85-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b8aeab",
    vectorEffect: "non-scaling-stroke",
    d: "m220 407.01 3.8-.66a1.07 1.07 0 0 0 .89-1.07l-.06-6.62a.91.91 0 0 0-.63-.85l-60.75-19.42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f9f9f9",
    vectorEffect: "non-scaling-stroke",
    d: "M163.25 378.39q-3.91-12.32-7.59-23.98c-1.38-4.36-1.9-8.31-2.49-12.73-.51-3.8-2.08-8.94-2.07-13.68q.04-8.56-.22-17.12c-.06-1.83.31-4.32-.01-6.53q-.44-2.97-.3-4.76c.58-7.15-.38-14.87-.14-21.11.34-8.8.94-17.53.23-26.33-1.07-13.27-.28-26.69-.4-40.01-.02-2.49.7-4.94.73-7.51q.2-18.84-.13-37.69-.01-.51.24-.94 1.5-2.66 2.48-7.25c3.17-14.86 15.32-17.24 27.84-20.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a8b5b0",
    vectorEffect: "non-scaling-stroke",
    d: "M181.42 137.87q3.28 3.58 9.06 3.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b1c1bc",
    vectorEffect: "non-scaling-stroke",
    d: "M190.48 141.23c13.81 1.21 18.63-19.94 18.31-30.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a8b5b0",
    vectorEffect: "non-scaling-stroke",
    d: "m208.79 111.14-.05-2.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9da6a2",
    vectorEffect: "non-scaling-stroke",
    d: "M208.74 109.08q-.09-8.79-4.67-16.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cdb8bd",
    vectorEffect: "non-scaling-stroke",
    d: "m204.07 92.58 2.68-5.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fbf4f4",
    vectorEffect: "non-scaling-stroke",
    d: "m206.75 86.92 2.81.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#caa5b0",
    vectorEffect: "non-scaling-stroke",
    d: "M209.56 87.42c1.92 3.63 5.3 4.87 8.71 2.15q4.28-3.41 5.98-10.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fbf4f4",
    vectorEffect: "non-scaling-stroke",
    d: "M224.25 79.14q1.16-12.98.99-27.14-.02-1.16.48-2.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e4c6cf",
    vectorEffect: "non-scaling-stroke",
    d: "M225.72 49.37q.56-.83.56-2.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fbe7ee",
    vectorEffect: "non-scaling-stroke",
    d: "M226.28 47.13c-.52-1.65-1.63-2.79-3.48-3.05q-13.08-1.89-26.41-3.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f3dbe3",
    vectorEffect: "non-scaling-stroke",
    d: "M196.39 40.75q-9.59-7.93-15.57-18.76c-1.03-1.87-1.95-1.72-3.82-1.97q-28.34-3.73-56.7-7.34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7e1e9",
    vectorEffect: "non-scaling-stroke",
    d: "M120.3 12.68 22.65.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebbdcc",
    vectorEffect: "non-scaling-stroke",
    d: "M120.3 12.68q-2.43 4.41-3.97 9.11c-1.48 4.51-7.35 6.92-11.59 7.84q-.68.15 0 .3.81.19.77.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f3c9d7",
    vectorEffect: "non-scaling-stroke",
    d: "m105.51 30.38-47.95-5.75q-.5-.06-.79.36-1.28 1.88-1.37 4.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dca8b9",
    vectorEffect: "non-scaling-stroke",
    d: "m55.4 29.48-5.3 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebbdcc",
    vectorEffect: "non-scaling-stroke",
    d: "m50.1 32.68-2.13-.19q-.48-.04-.57-.52-.4-2.07-1.72-2.65c-7.06-3.12-10.52-5.1-14.47-11.01Q25.46 9.69 22.65.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7a2b3",
    vectorEffect: "non-scaling-stroke",
    d: "M50.1 32.68Q27.71 44.93 5.04 56.52q-2.06 1.05-2.57 2.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eecfd7",
    vectorEffect: "non-scaling-stroke",
    d: "m2.47 59.37-1.24.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#efc2d1",
    vectorEffect: "non-scaling-stroke",
    d: "M196.39 40.75q-.13.03-.27.26-.17.3-.52.26l-90.09-10.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0aebe",
    vectorEffect: "non-scaling-stroke",
    d: "m226.28 47.13-1.24.85a1.36 1.35 30.8 0 1-.93.23Q143.45 38.8 62.75 29.75q-1.76-.2-7.35-.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dfbbc4",
    vectorEffect: "non-scaling-stroke",
    d: "m225.72 49.37-26.75-2.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dca8b9",
    vectorEffect: "non-scaling-stroke",
    d: "m198.97 46.42-25.79-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dfbbc4",
    vectorEffect: "non-scaling-stroke",
    d: "m173.18 43.6-28.1-3.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0aebe",
    vectorEffect: "non-scaling-stroke",
    d: "m145.08 40.25-28.13-3.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e3c1ca",
    vectorEffect: "non-scaling-stroke",
    d: "m116.95 37.1-29.6-3.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0aebe",
    vectorEffect: "non-scaling-stroke",
    d: "m87.35 33.72-29.21-3.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dfbbc4",
    vectorEffect: "non-scaling-stroke",
    d: "M58.14 30.25h-1.43a2.05 2.04-59.8 0 0-.94.25l-12.22 6.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7a2b3",
    vectorEffect: "non-scaling-stroke",
    d: "m43.55 37.27-11 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dfbbc4",
    vectorEffect: "non-scaling-stroke",
    d: "m32.55 43.07-11.22 6.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7a2b3",
    vectorEffect: "non-scaling-stroke",
    d: "m21.33 49.15-10.16 5.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dfbbc4",
    vectorEffect: "non-scaling-stroke",
    d: "m11.17 54.64-8.7 4.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#989a97",
    vectorEffect: "non-scaling-stroke",
    d: "m11.66 84.2-1.54 5.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c6c0bd",
    vectorEffect: "non-scaling-stroke",
    d: "M10.12 90.19c-.95 2.77-2.65 5.99-6.25 4.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fbe2e9",
    vectorEffect: "non-scaling-stroke",
    d: "m116.95 37.1-.37 27.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b5b1b1",
    vectorEffect: "non-scaling-stroke",
    d: "M116.58 64.83c-3.47 20.42-26.87 14.89-29.23-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f3d6dd",
    vectorEffect: "non-scaling-stroke",
    d: "m198.97 46.42.1 26.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c59aa6",
    vectorEffect: "non-scaling-stroke",
    d: "M199.07 72.61q-1.23 8.55-7.64 11.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c2879a",
    vectorEffect: "non-scaling-stroke",
    d: "M191.43 84.36q-7.17 2.79-13.66-2.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c59aa6",
    vectorEffect: "non-scaling-stroke",
    d: "M177.77 81.48q-3.96-3.94-5.28-10.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a48c94",
    vectorEffect: "non-scaling-stroke",
    d: "m44.45 69.4-2.67 8.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a18085",
    vectorEffect: "non-scaling-stroke",
    d: "m41.78 78.02-1.55 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#88737a",
    vectorEffect: "non-scaling-stroke",
    d: "M40.23 80.39c-4.1 4.91-7.17-3.08-7.41-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eecfd7",
    vectorEffect: "non-scaling-stroke",
    d: "m32.82 73.9-.27-30.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#88737a",
    vectorEffect: "non-scaling-stroke",
    d: "M21.97 80.1c-1.3 3.84-1.56 7.69-5.27 10.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#908186",
    vectorEffect: "non-scaling-stroke",
    d: "M16.7 90.88c-3.99.14-4.03-3.96-5.04-6.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eecfd7",
    vectorEffect: "non-scaling-stroke",
    d: "m11.66 84.2-.49-29.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7dbe2",
    vectorEffect: "non-scaling-stroke",
    d: "M58.14 30.25q-.49 1.65-.65 5.72-.67 16.7-.07 26.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b1abaa",
    vectorEffect: "non-scaling-stroke",
    d: "M57.42 62.13q-1.48 8.04-5.18 13.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aca5a5",
    vectorEffect: "non-scaling-stroke",
    d: "M52.24 76.01c-5.37 2.66-6.42-2.42-7.79-6.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eecfd7",
    vectorEffect: "non-scaling-stroke",
    d: "M44.45 69.4c-1.44-10.38-.63-21.42-.9-32.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#908c8b",
    vectorEffect: "non-scaling-stroke",
    d: "M32.82 73.9c-.37 4.69-6.37 22.36-10.85 6.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eecfd7",
    vectorEffect: "non-scaling-stroke",
    d: "M21.97 80.1c-.12-2.07-.72-4.1-.72-6.16q-.03-12.28.08-24.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c699a5",
    vectorEffect: "non-scaling-stroke",
    d: "M224.25 79.14q-4.72 10.21-14.69 8.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9adb1",
    vectorEffect: "non-scaling-stroke",
    d: "M206.75 86.92c.08-.65-.11-1.21-.69-1.62q-6.2-4.47-6.99-12.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7dbe2",
    vectorEffect: "non-scaling-stroke",
    d: "m145.08 40.25-.01 25.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ac989f",
    vectorEffect: "non-scaling-stroke",
    d: "M145.07 65.84q-.84 13.52-13.38 14.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b29ea4",
    vectorEffect: "non-scaling-stroke",
    d: "M131.69 80.68q-12.67-2.28-15.11-15.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f3d6dd",
    vectorEffect: "non-scaling-stroke",
    d: "m173.18 43.6-.69 27.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c9adb1",
    vectorEffect: "non-scaling-stroke",
    d: "M172.49 70.91q-1.92 9.12-9.2 11.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ba9099",
    vectorEffect: "non-scaling-stroke",
    d: "M163.29 82.57q-6.89 1.54-12.35-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aca5a5",
    vectorEffect: "non-scaling-stroke",
    d: "M150.94 79.46q-5.45-5.05-5.87-13.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fbe2e9",
    vectorEffect: "non-scaling-stroke",
    d: "M87.35 33.72v28.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b29ea4",
    vectorEffect: "non-scaling-stroke",
    d: "M87.35 61.93c-3.38 18.96-25.32 16.12-29.93.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#35443e",
    vectorEffect: "non-scaling-stroke",
    d: "m30.47 106.45.26 3.22a.77.76-77.6 0 0 .38.61l.29.17q.6.36.6-.34v-2.59a.61.6-.5 0 1 .6-.6c7.18-.13 10.53 2.1 15.84 5.12q4.49 2.55 12.7 3.33c2.39.23 4.75 1.24 7.33 1.36 2.51.13 4.31 1.4 6.86 1.49 4.79.17 9.56.35 14.29 1.16q2.31.4 4.65.45c5.42.12 8.53.43 12.88.76q2.28.17 4.33 1.29 4.91 2.66 10.05 4.84c2.59 1.1 4.65 2.83 7.2 4.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24302c",
    vectorEffect: "non-scaling-stroke",
    d: "m128.73 130.89.01 13.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "M128.74 144.06q-4.55-2.46-9.01-4.79-1.26-.66-3.46-2.63-3.04-2.72-7.51-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#68726c",
    vectorEffect: "non-scaling-stroke",
    d: "m108.76 133.68-.31-8.03a1.12 1.11-89.4 0 0-1.04-1.07l-49.43-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757f78",
    vectorEffect: "non-scaling-stroke",
    d: "m57.98 121.48-6.35-.05q-.57 0-.58.56l-.06 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "m50.99 124.49-.55 3.12a.82.81-57.1 0 1-1.48.32q-.86-1.26-.2-2.61a1.23 1.21 47 0 0 .03-1.04q-.75-1.73-.25-3.61.14-.55-.26-.95c-3.34-3.37-10.29-8.04-15.65-7.99q-.58 0-.59.59l-.24 9.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#526c63",
    vectorEffect: "non-scaling-stroke",
    d: "m31.8 121.63-.13 13.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "M31.67 134.99q-.47.78-1.38.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#567066",
    vectorEffect: "non-scaling-stroke",
    d: "m30.29 135.43-.05-21.36q-.01-.48-.34-.83-1.93-1.97-4.15-3.54c-3.52-2.49-5.4-4.91-8.05-8.02a1.16 1.16 0 0 0-2.04.85q.12 1.31-1.41.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#68726c",
    vectorEffect: "non-scaling-stroke",
    d: "M13.97 99.53q.9-4.69-3.85-9.34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#676767",
    vectorEffect: "non-scaling-stroke",
    d: "M131.69 80.68c-.27 1.15-2.03 4.3-3.46 3.21q-.35-.27-.81-.23c-5.55.46-10.51-.59-16.02-.95q-2.85-.18-5.66-.93-.5-.13-.98.06c-2.79 1.07-6.05.12-8.16.17q-6.07.13-12.14-.92-.54-.09-.94-.47-1.87-1.76-4.41-.88-.49.16-.97 0-1.54-.5-3.22-.62c-1.67-.11-3.86 1.33-5.75-.31q-.38-.33-.88-.41c-1.89-.28-3.29.24-5.18-.16q-3.83-.8-7.75-.21-.49.08-.87-.23l-2.25-1.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6b5f60",
    vectorEffect: "non-scaling-stroke",
    d: "M204.07 92.58q-.16.43-.79.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ae9397",
    vectorEffect: "non-scaling-stroke",
    d: "M203.28 93.01q.23-.33.17-.65-.12-.58-.57-.2l-2.42 2.03a.28.28 0 0 0 .09.48q.4.12.46.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6b5f60",
    vectorEffect: "non-scaling-stroke",
    d: "M201.01 94.94c-4.3 2.02-7.39-2.49-8.35-6.04q-.17-.64-.58-.11-.55.75-.33 2.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a6888d",
    vectorEffect: "non-scaling-stroke",
    d: "M191.75 91.1q-.46-.33-.93.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#985e6e",
    vectorEffect: "non-scaling-stroke",
    d: "M190.82 91.28c-.4-2.58 2.01-5.65.61-6.92M177.77 81.48l-.33 8.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a69193",
    vectorEffect: "non-scaling-stroke",
    d: "M177.44 90.15q-.54 1.49-.62 3.23c-.23 5.21-7.83 14.5-11.68 5.41q-.67-1.59-1.81-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c5462",
    vectorEffect: "non-scaling-stroke",
    d: "m163.33 96.09-.04-13.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a37580",
    vectorEffect: "non-scaling-stroke",
    d: "M190.82 91.28c-1.65 4.62-5 9.51-10.55 6.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#684b53",
    vectorEffect: "non-scaling-stroke",
    d: "M180.27 97.87q.09-.58-.58-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a37e86",
    vectorEffect: "non-scaling-stroke",
    d: "m179.69 96.7-2.25-6.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6f4c56",
    vectorEffect: "non-scaling-stroke",
    d: "m150.94 79.46-.18 19.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#898986",
    vectorEffect: "non-scaling-stroke",
    d: "M150.76 98.82c-1.03 2.31-.69 4.67-1.67 6.83q-2.53 5.61-6.18 11.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464847",
    vectorEffect: "non-scaling-stroke",
    d: "m142.91 116.77-.06-25.74q0-.62-.62-.69-2.47-.27-4.4-1.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5e5652",
    vectorEffect: "non-scaling-stroke",
    d: "M137.83 88.65q-1.65-2.77-3.9-2.63-1.38.09-1.47.08-14.24-.68-28.48-1.26c-2.4-.1-4.87-1.17-7.73-1.58q-11.37-1.62-19.22-1.77c-2.26-.04-4.49-1.15-7.13-.54q-.47.11-.92-.09c-2.26-.99-6.26-.48-8.81-.65-1.69-.12-3.55-1.2-5.85-.46a1.58 1.55-43.8 0 1-.99-.01q-2.57-.85-5.25-.57-.54.06-1.02-.19-2.5-1.28-5.28-.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#433d38",
    vectorEffect: "non-scaling-stroke",
    d: "M40.23 80.39q12.19.62 24.23 2.12c6.76.85 13.49 1.24 20.26 1.97q6.91.76 13.85 1.17 11.85.71 13.85.87 12.9 1.02 25.41 2.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d706c",
    vectorEffect: "non-scaling-stroke",
    d: "m142.91 116.77-.1 10.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323e39",
    vectorEffect: "non-scaling-stroke",
    d: "M142.81 127.23c.16 2.91-.27 3.57-2.95 3.89q-4.82.59-9.18 1.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1c2220",
    vectorEffect: "non-scaling-stroke",
    d: "m130.68 133.11.12-29.3a.92.91-87.7 0 0-.85-.93L30.99 95.4q-.77-.05-.56.69l.36 1.23a.56.55 78.8 0 0 .59.4c5.51-.64 11.82.48 16.05.66q8.47.36 16.89 1.4c2.53.31 5.13.12 7.75.31q28.14 2.08 56 4.29a.73.73 0 0 1 .68.73l.01 19.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2d3532",
    vectorEffect: "non-scaling-stroke",
    d: "M128.76 124.46q-8.81-6.59-19.24-8.96c-6.89-1.57-14.83.6-21.52-1.55-4.73-1.52-9.09.47-13.76-.94q-9.76-2.97-19.85-4.4-3.8-.54-7.22-1.85c-2.12-.82-17.07-7.24-15.16-.49a.6.6 0 0 1-.95.64l-.59-.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323e39",
    vectorEffect: "non-scaling-stroke",
    d: "M30.47 106.45c1.18-5.48-4.52-5.32-7.86-6.78q-.47-.21-.74-.64l-5.17-8.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#97747b",
    vectorEffect: "non-scaling-stroke",
    d: "M163.33 96.09c-1.11 7.81-8.92 16.58-12.57 2.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#68857b",
    vectorEffect: "non-scaling-stroke",
    d: "m31.54 153.51.39 132.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#648278",
    vectorEffect: "non-scaling-stroke",
    d: "m31.93 286.21-.15 40.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#617f74",
    vectorEffect: "non-scaling-stroke",
    d: "m31.78 327.05-.12 30.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59776d",
    vectorEffect: "non-scaling-stroke",
    d: "m31.66 357.49-.18 19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40534c",
    vectorEffect: "non-scaling-stroke",
    d: "m31.48 376.49-.9-.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59776d",
    vectorEffect: "non-scaling-stroke",
    d: "m30.58 376.46-.28-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#648278",
    vectorEffect: "non-scaling-stroke",
    d: "M30.29 323.99 30.07 257"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "M128.75 157.44v7.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59776d",
    vectorEffect: "non-scaling-stroke",
    d: "M128.75 164.9q-1.5-2.56-2.78-3.13c-4.26-1.91-8.32-3.51-11.72-6.98q-2.61-2.66-5.45-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24302c",
    vectorEffect: "non-scaling-stroke",
    d: "m130.68 133.11.07 9.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2f3f3a",
    vectorEffect: "non-scaling-stroke",
    d: "m130.75 142.54-.01 14.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24302c",
    vectorEffect: "non-scaling-stroke",
    d: "M130.74 156.72q-.83.81-1.99.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2f3f3a",
    vectorEffect: "non-scaling-stroke",
    d: "m128.75 157.44-.01-13.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1f2825",
    vectorEffect: "non-scaling-stroke",
    d: "m128.73 130.89.03-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#73817a",
    vectorEffect: "non-scaling-stroke",
    d: "m108.76 133.68-.22 9.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#617f74",
    vectorEffect: "non-scaling-stroke",
    d: "m30.29 135.43-.39 1.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#799a8e",
    vectorEffect: "non-scaling-stroke",
    d: "M29.9 137.08q-1.62-1.29-2.64-3.18c-2.14-3.99-4.75-6.16-5.47-11.03q-.07-.5-.42-.85c-2.38-2.44-.97-6.27-4.17-7.78q-.46-.22-.45.29c.2 12.72.57 26.3.49 38.19q-.4 61.12-.2 122.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75968b",
    vectorEffect: "non-scaling-stroke",
    d: "M17.04 275.03q-.06 21.03-.05 42.1c.01 10.13-.92 21.6-1 32.45-.01 1.12.62 2.26 1.08 3.19a.84.83 43.4 0 0 1.52-.04q1.41-3.31 2.14-6.23c1.21-4.85 3.72-8.51 6.04-12.73q.66-1.2 2.67-.72.59.14.61-.47l.24-8.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#617f74",
    vectorEffect: "non-scaling-stroke",
    d: "m30.29 323.99.01 47.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6a8b80",
    vectorEffect: "non-scaling-stroke",
    d: "M30.3 371.8q-5.75 3.21-8.52 6.99-2.55 3.49-5.66 4.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#71786f",
    vectorEffect: "non-scaling-stroke",
    d: "M16.12 383.28c0-.05-.54-9.3-1.87-7.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a3a49f",
    vectorEffect: "non-scaling-stroke",
    d: "m57.98 121.48 1.04.31q.46.14.65.59c.8 1.92 10.43 3.38 13.03 4.39q6.25 2.43 21.8 4.67 12.17 1.75 14.04 11.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#808e86",
    vectorEffect: "non-scaling-stroke",
    d: "m108.54 142.77.26 7.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#899a92",
    vectorEffect: "non-scaling-stroke",
    d: "m108.8 149.79.17 28.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#91a299",
    vectorEffect: "non-scaling-stroke",
    d: "m108.97 178.55-.04 5.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#babdb6",
    vectorEffect: "non-scaling-stroke",
    d: "M108.93 183.73q-1.99-7.47-1.69-15.68c.09-2.41-2.47-3.62-4.25-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d1d2cf",
    vectorEffect: "non-scaling-stroke",
    d: "m102.99 166.55-.56-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#babdb6",
    vectorEffect: "non-scaling-stroke",
    d: "M102.43 156.55c-1.42-2.16-6.59-1.64-9.29-1.4q-2.11.19-2.28-1.93c-.73-9.06-12.13-13.39-18.12-6.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d1d2cf",
    vectorEffect: "non-scaling-stroke",
    d: "m72.74 147.18-.87 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#babdb6",
    vectorEffect: "non-scaling-stroke",
    d: "M71.87 148.72q-9.82-5.43-20.86-8.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#808e86",
    vectorEffect: "non-scaling-stroke",
    d: "m50.99 124.49.02 16.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8a9991",
    vectorEffect: "non-scaling-stroke",
    d: "m51.01 140.55-.09 1.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59776d",
    vectorEffect: "non-scaling-stroke",
    d: "M50.92 142.47c-.25 1.71-.01 6.38-2.17 6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5d7b71",
    vectorEffect: "non-scaling-stroke",
    d: "m48.75 148.97-.26-14.63q-.01-.44-.37-.67c-2.42-1.58-4.17-4.21-6.23-5.63q-4.74-3.27-10.09-6.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#66887d",
    vectorEffect: "non-scaling-stroke",
    d: "m48.75 148.97-.02 18.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75968b",
    vectorEffect: "non-scaling-stroke",
    d: "M48.73 167.53q-3.91-3.03-6.08-7.37c-1.46-2.93-4.79-7.8-7.12-10.01q-1.47-1.4-3.11-3.46a.21.21 0 0 0-.38.12l-.5 6.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5d7b71",
    vectorEffect: "non-scaling-stroke",
    d: "m31.54 153.51.13-18.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b8aaa9",
    vectorEffect: "non-scaling-stroke",
    d: "M199.85 109.7c-5.22 1.39-3.04 5.84-8.07 7.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a37580",
    vectorEffect: "non-scaling-stroke",
    d: "M191.78 116.94q-.43-6.76-3.56-14.35a1.85 1.85 0 0 0-2.9-.71q-2.5 2.09-2.72 5.85c-.08 1.3-1.05 2.27-1.25 3.57q-.95 6.28-1.03 13.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b8aaa9",
    vectorEffect: "non-scaling-stroke",
    d: "M180.32 124.45q-3.09-2-3.43.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#808580",
    vectorEffect: "non-scaling-stroke",
    d: "m176.89 124.92-.59-2.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757672",
    vectorEffect: "non-scaling-stroke",
    d: "M176.3 121.98q-1.54-12.62 3.97-24.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7d817c",
    vectorEffect: "non-scaling-stroke",
    d: "M201.01 94.94q1.36-.67 2.27-1.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "m208.74 109.08-3.25-.4a1.1 1.08 24.2 0 0-.92.34q-2 2.21-4.59 3.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7d817c",
    vectorEffect: "non-scaling-stroke",
    d: "m199.98 112.03-.13-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757672",
    vectorEffect: "non-scaling-stroke",
    d: "M199.85 109.7q.12-7.91-4.15-14.73c-1-1.6-2.59-2.55-3.95-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757f78",
    vectorEffect: "non-scaling-stroke",
    d: "M179.69 96.7q-4.26 8.12-4.48 17.39 0 .38-.38.46l-3.8.74q-.46.1-.69.51-1.89 3.43.24 6.27.33.44.89.43l2.29-.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c0c3bd",
    vectorEffect: "non-scaling-stroke",
    d: "M173.76 122.47q-3.27 2.6-4.99 2.44-11.26-1.08-20.23 1.24-3.32.85-5.58 4.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757f78",
    vectorEffect: "non-scaling-stroke",
    d: "m142.96 130.7-.15-3.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "M176.3 121.98q-1.2.6-1.59-.28-.19-.42-.57-.15-.31.24-.38.92M142.86 137.43q.28 3.06-.79 4.4-.35.43-.9.44l-10.42.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#546a63",
    vectorEffect: "non-scaling-stroke",
    d: "m127.99 370.96-96.74 8.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#648278",
    vectorEffect: "non-scaling-stroke",
    d: "m84.46 291.55-35.28 1.28a.41.41 0 0 0-.28.7l.32.32q.17.17.17.41l-.38 17.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75968b",
    vectorEffect: "non-scaling-stroke",
    d: "m49.01 311.74-1.5 10.72q-.07.47-.46.2c-.68-.49-4 2.1-5.46 3.15-2.86 2.06-5.88 1.31-8.45-.58q-.41-.31-.62.16l-.74 1.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#68857b",
    vectorEffect: "non-scaling-stroke",
    d: "M29.9 137.08 30.07 257"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7c9d92",
    vectorEffect: "non-scaling-stroke",
    d: "m30.07 257-2.69 4.07q-.28.43-.8.43h-.48q-.47 0-.66.43-1.64 3.85-3.27 7.69c-1.15 2.73-1.83 5.79-5.13 5.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75968b",
    vectorEffect: "non-scaling-stroke",
    d: "M50.09 356.8q-.2.46-.05.79.22.46.72.47l4.22.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#495f58",
    vectorEffect: "non-scaling-stroke",
    d: "M128.66 368.45q-.99.68-1.67.74-47.14 4.41-94.33 8.25c-.57.04-1.55-.21-1.18-.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6a8b80",
    vectorEffect: "non-scaling-stroke",
    d: "m31.66 357.49.38 3.98q.05.46.41.17c1.54-1.24 4.11-.11 5.8-.39q4.24-.69 10.24-2.9.47-.17.95-.06 2.89.65 5.54-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d8e83",
    vectorEffect: "non-scaling-stroke",
    d: "M54.98 358.09q.99-1.01 3.27-1 7.73.07 18.96-1.03c12.21-1.19 23.77-1.77 35.65-3.04a.64.63-2.6 0 0 .57-.62l.08-9.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99aca4",
    vectorEffect: "non-scaling-stroke",
    d: "m142.93 345.49.15 28.48q0 .46.46.52l.71.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#697067",
    vectorEffect: "non-scaling-stroke",
    d: "M144.25 374.58q-.19-.04-.37-.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f675e",
    vectorEffect: "non-scaling-stroke",
    d: "M143.88 374.5q-3.87 3.45-9.8 2.62a.61.61 0 0 1-.52-.57l-.2-3.52a.62.61-15.3 0 0-.9-.51c-1.66.84.46 2.84-1 4.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#465953",
    vectorEffect: "non-scaling-stroke",
    d: "m131.46 377.05-101.97 9.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f675e",
    vectorEffect: "non-scaling-stroke",
    d: "M29.49 386.42q-.47.42-1.02.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#697067",
    vectorEffect: "non-scaling-stroke",
    d: "m28.47 386.98-10.11.95a.93.92-21.5 0 1-.82-.35q-1.16-1.51-1.42-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#495f58",
    vectorEffect: "non-scaling-stroke",
    d: "M30.58 376.46q-.41 3.64.67 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d8e83",
    vectorEffect: "non-scaling-stroke",
    d: "M31.25 379.28q-1 1.35-1.04 2.41-.02.56.52.38c1.19-.41 2.42-.87 3.72-.93 11.41-.54 22.96-2.42 33.95-3.1 8.99-.56 14.72-1.64 22.04-1.98q6.31-.3 7.62-.46 15.09-1.9 29.89-2.54a1.31 1.3 19.3 0 0 .9-.43q1.69-1.92-.86-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#495f58",
    vectorEffect: "non-scaling-stroke",
    d: "m127.99 370.96 2.19-.43a.63.62 79.5 0 0 .49-.72l-.24-1.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#adc0b7",
    vectorEffect: "non-scaling-stroke",
    d: "m50.88 270.17 57.2-1.53q.59-.01.59-.6l.09-65.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a2b4ab",
    vectorEffect: "non-scaling-stroke",
    d: "m108.76 202.24.26-3.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#799a8e",
    vectorEffect: "non-scaling-stroke",
    d: "M109.02 198.55q1.26-2.1.58-4.98a1.41 1.41 0 0 1 1.87-1.65l1.77.67a.7.7 0 0 1 .46.66l.06 77.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7c9d92",
    vectorEffect: "non-scaling-stroke",
    d: "M113.76 270.42q-.21.31-.29.99-.06.53-.59.54-19.79.54-39.56 1.23-2.48.09-5.49 2.12c-3.05 2.05-9.45 3.19-12.87 4.15q-3.54 1-7.21 1.52-.48.07-.85.37-2.46 1.98-5.24 3.5c-2.65 1.45-3.35 3.89-7.31 3.29a.87.86 24 0 0-.79.3q-.51.63-.64 1.42a.02.01-57.4 0 1-.03.01l-.18-.35q-.12-.22-.16.03-.05.25-.15.47a.1.1 0 0 1-.19-.04l-.28-3.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4e685f",
    vectorEffect: "non-scaling-stroke",
    d: "m128.75 164.9-.02 46.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6a8b80",
    vectorEffect: "non-scaling-stroke",
    d: "m128.73 211.01-.46-6.02q-.02-.18-.19-.22-.15-.04-.26-.1-.34-.17-.44-.53-2.96-11.1-12.15-17.8-.4-.3-.44-.8c-.22-2.95-.56-8.07-3.83-9.34q-.5-.19-.7.31-.44 1.16-1.29 2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4e685f",
    vectorEffect: "non-scaling-stroke",
    d: "m130.76 163.5.01 17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#567066",
    vectorEffect: "non-scaling-stroke",
    d: "M130.77 180.5c-.05 24.25-.71 48.83.31 73.04.3 7.12-.29 17.14-.31 21.36q-.05 9.67-.03 19.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4e685f",
    vectorEffect: "non-scaling-stroke",
    d: "m130.74 294.26-.05 73.31q0 .29-.14.55-.09.16-.12.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#35443e",
    vectorEffect: "non-scaling-stroke",
    d: "m130.43 368.49-1.77-.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4e685f",
    vectorEffect: "non-scaling-stroke",
    d: "m128.66 368.45.15-99.41q0-.49-.45-.72c-2.19-1.08-5.35-.21-6.03-3.31a1.14 1.13 6.8 0 0-.61-.77q-.66-.31-.87-1.14-.12-.51.33-.77 1.15-.66 3.52 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5d766d",
    vectorEffect: "non-scaling-stroke",
    d: "M124.7 262.33c5.45-.14 5.98-5.16 4.01-9.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#567066",
    vectorEffect: "non-scaling-stroke",
    d: "m128.71 253.27.02-42.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59776d",
    vectorEffect: "non-scaling-stroke",
    d: "m142.7 161.43-.59 1.55a.59.58 23.8 0 1-.81.31q-2.31-1.2-4.6-.03-.48.24-1.01.24h-4.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#455b53",
    vectorEffect: "non-scaling-stroke",
    d: "m130.76 163.5-.02-6.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b1a7a4",
    vectorEffect: "non-scaling-stroke",
    d: "m220 407.01-2.01.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9f928c",
    vectorEffect: "non-scaling-stroke",
    d: "M217.99 407.21q-101.37 11.5-155.68 17.85-3.25.38-5.69.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09893",
    vectorEffect: "non-scaling-stroke",
    d: "M56.62 425.12 3.64 396.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#799a8e",
    vectorEffect: "non-scaling-stroke",
    d: "M128.71 253.27c-3.41-1.85-12.51-3.37-12.37 3.29q.07 3.71 3.43 4.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6a8b80",
    vectorEffect: "non-scaling-stroke",
    d: "M119.77 261.48q-.78 2.56 2.9 6.95.33.39.78.6 1.75.84 3.2 2.11.38.33.52.82c.58 2.1 1.33 3.92 1.34 6.12q0 4.9-.02 9.84a.19.19 0 0 1-.35.1l-.15-.25a.6.6 0 0 0-1.12.31c.02 7.16.87 14.72-1.39 21.17-.76 2.18-.54 3.98-1.09 6.16q-.54 2.19-.52 4.26.07 4.86-2.03 9.38-1.86 4.01-4.35 7.67-.24.35-.57.64-1.33 1.18-2.13.32-.6-.65-.7.23l-.58 5.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75968b",
    vectorEffect: "non-scaling-stroke",
    d: "M113.51 343.28 113.5 329q0-.59-.52-.31c-1.51.8-1.03 17.93-1.01 20.59q.01.52-.4.84-.76.63-1.57-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6e9084",
    vectorEffect: "non-scaling-stroke",
    d: "m110 349.72.06-52.41a.36.36 0 0 0-.62-.26q-1.53 1.55-1.33 3.78.04.44-.1.86-.83 2.42-2.89 3.81-.46.31-.56.86l-.82 4.78q-.09.52-.59.33-1.21-.45-2.38.68-.34.32-.58.73-1.71 2.88-5.07 2.16-.64-.14-1.18.21l-5.42 3.48a1.74 1.7-59.2 0 1-1.02.27q-1.64-.09-2.94.82-.43.29-.59.79c-1.58 4.86-6.73 3.56-10.51 3.66a1.19 1.19 0 0 0-1.01.59l-.89 1.52q-.31.52-.15 1.11.59 2.18-1.42 2.85-.53.18-1.06 0-3.23-1.11-5.57 1.11-.41.39-.98.43-2.71.21-5.45.18-.53 0-.71.49l-.53 1.39a1.34 1.33 53.1 0 1-2.58-.37l-.3-3.8q-.04-.52-.56-.56-.93-.07-1.23-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#617f74",
    vectorEffect: "non-scaling-stroke",
    d: "m51.02 326.96-.07-30.35q0-.63.62-.65l57.71-2.22q.63-.03.87-.61.31-.76 1.15-.92a.59.59 0 0 1 .7.58v1.14q0 1.54.2.01.18-1.41.12-2.83-.02-.5-.52-.49l-27.34.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#75968b",
    vectorEffect: "non-scaling-stroke",
    d: "M84.46 291.55q1.91-.4 2.98-1.25.1-.07.16-.18.28-.47-.24-.34a.21.21 0 0 1-.19-.36q1.2-1.02 2.56-.46.56.23.77-.34c1.95-5.27 5.07-2.79 8.71-4.5q1.63-.77 3.05-1.93.41-.35.93-.2c4.94 1.4 5.15-4.86 9.38-2.89a.94.94 0 0 0 1.33-.87l-.14-7.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbddda",
    vectorEffect: "non-scaling-stroke",
    d: "m71.87 148.72-1.25 4.03q-.15.5-.67.57c-4.52.57-12.65-2.62-11.7 5.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfd4cd",
    vectorEffect: "non-scaling-stroke",
    d: "M58.25 159.1q-3.46.81-6.61-.11-.45-.13-.54.33l-.31 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#93a69d",
    vectorEffect: "non-scaling-stroke",
    d: "m50.79 161.01.13-18.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbddda",
    vectorEffect: "non-scaling-stroke",
    d: "M102.43 156.55q-.22-.04-.39-.05-.46-.04-.46.42l-.14 15.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cacec8",
    vectorEffect: "non-scaling-stroke",
    d: "m101.44 172.25-.19-.36q-.32-.59-.26.08.01.14.01.29-.01.39-.4.41l-6.19.35a1.19 1.18 63.8 0 1-.86-.3q-1.44-1.24-2.92-.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d5bfc4",
    vectorEffect: "non-scaling-stroke",
    d: "M90.63 172.19q1.91-1.8.16-3.75a1.25 1.23-19.5 0 0-.88-.41l-10.16-.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cacec8",
    vectorEffect: "non-scaling-stroke",
    d: "M79.75 167.7c2.47-3.54-.52-5.58-2.59-7.98q-.35-.41-.87-.55-2.64-.74-4.09-2.96-.39-.59-1.1-.56l-8.92.38a.58.57 24.8 0 1-.38-1.03l.73-.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbddda",
    vectorEffect: "non-scaling-stroke",
    d: "m62.53 154.44 8.34.23a.94.94 0 0 0 .95-1.08q-.44-2.87 1.38-5.35.73-1-.46-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9baea4",
    vectorEffect: "non-scaling-stroke",
    d: "m108.93 183.73.09 14.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e3e1",
    vectorEffect: "non-scaling-stroke",
    d: "M62.53 154.44q-3.28-.81-3.28 2.06-.02 9.36.02 18.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e6e9e6",
    vectorEffect: "non-scaling-stroke",
    d: "m59.27 174.85-.11 45.36a1.73 1.73 0 0 0 1.55 1.73l8.77.93a2.54 2.54 0 0 1 2.28 2.46c.3 10.22 17.33 11.76 18.17-.97A1.47 1.45 88.4 0 1 91.2 223q3.51-.46 7.2-.08a2.82 2.82 0 0 0 3.11-2.81l-.04-26.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e3e1",
    vectorEffect: "non-scaling-stroke",
    d: "m101.47 193.2-.03-20.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbddda",
    vectorEffect: "non-scaling-stroke",
    d: "m102.99 166.55.02 32.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e6e9e6",
    vectorEffect: "non-scaling-stroke",
    d: "m103.01 198.77-.05 22.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d1d2cf",
    vectorEffect: "non-scaling-stroke",
    d: "M102.96 220.84q-.45 4.81-11.27 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e6e9e6",
    vectorEffect: "non-scaling-stroke",
    d: "M91.69 223.64q-.36.53-.67 1.04-.28.46-.42 1.12-2.09 9.87-10.98 8.63c-4.92-.69-7.92-5.3-9.16-9.74q-.15-.53-.7-.55l-9.45-.38a2.19 2.19 0 0 1-2.11-2.19l.05-62.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9eb2a9",
    vectorEffect: "non-scaling-stroke",
    d: "m50.79 161.01.09 109.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#719287",
    vectorEffect: "non-scaling-stroke",
    d: "m50.88 270.17-.65 1.25a.61.6 58.7 0 1-1.14-.28l-.36-103.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ab808a",
    vectorEffect: "non-scaling-stroke",
    d: "M191.78 116.94q.79 2.99.35 4.99-.12.52-.65.62l-11.16 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59776d",
    vectorEffect: "non-scaling-stroke",
    d: "M208.79 111.14q.09.93-.37 1.51a.75.74-59.2 0 1-.86.22c-3.83-1.55-5.49.05-6.09 3.8-1.19 7.45-3.99 15.61-10.26 20.4-1.58 1.2-1.84 2.59-.73 4.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a1aeaa",
    vectorEffect: "non-scaling-stroke",
    d: "M181.42 137.87q-3.05-3.22-4.64-8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909f98",
    vectorEffect: "non-scaling-stroke",
    d: "m176.78 129.87-2-7.26q-.15-.55-.67-.3l-.35.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#88908a",
    vectorEffect: "non-scaling-stroke",
    d: "M176.89 124.92c1.5 6.85 7.44 16.76 15.48 9.37 5.38-4.93 7.65-15.09 7.61-22.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e3e1",
    vectorEffect: "non-scaling-stroke",
    d: "M176.78 129.87q-1.42.98-2.92.91-.49-.02-.86.28c-1.57 1.29-3.87.7-4.9 1.65q-.37.34-.87.39-13.35 1.26-24.27 8.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909f98",
    vectorEffect: "non-scaling-stroke",
    d: "m142.96 141.67-.1-4.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85908a",
    vectorEffect: "non-scaling-stroke",
    d: "m142.86 137.43.1-6.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5d7b71",
    vectorEffect: "non-scaling-stroke",
    d: "M51.02 326.96q0 13.01-.32 25.94c-.02 1-.49 1.27-1.41 1.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#617f74",
    vectorEffect: "non-scaling-stroke",
    d: "M49.29 354.25q.67-21.27-.28-42.51"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#719388",
    vectorEffect: "non-scaling-stroke",
    d: "m110 349.72-58.7 4.38a.62.62 0 0 0-.57.57q-.1 1.31-.64 2.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6e9084",
    vectorEffect: "non-scaling-stroke",
    d: "M50.09 356.8c-2.05-.04-1.08-1.52-.8-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#719287",
    vectorEffect: "non-scaling-stroke",
    d: "M124.7 262.33q-3.78-1.83-5.01-5.13-.29-.77-.41.04-.21 1.46.49 4.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09893",
    vectorEffect: "non-scaling-stroke",
    d: "m151.9 374.7-7.65-.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#66534d",
    vectorEffect: "non-scaling-stroke",
    d: "M143.88 374.5q1.29.19 1.5.91.14.46-.23.77-.95.81-.89 2.34c.13 3.62-4.36 5.96-7.13 7.46-6.65 3.58-15.51 2.53-22.81 3.27-2.92.3-8.48-.62-10.85 1.28q-.36.3-.83.26c-3.75-.27-7.4.56-10.9.35-7.97-.48-16.4.62-24.16-.71q-6.41-1.1-12.91.09a1.8 1.72 48.4 0 1-.97-.08c-2.73-1.01-6.19-.62-8.37-.8-6.36-.53-12.33 2.34-18.4-.78q-.5-.25.02-.47l1.53-.67q.36-.15.15-.49l-.16-.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#433d38",
    vectorEffect: "non-scaling-stroke",
    d: "M29.49 386.42q-.19 1.43 1.26 1.33c13.84-.92 31.26-3.29 46.72-4.47q27.56-2.12 54.85-4.84a.55.55 0 0 0 .12-1.06l-.98-.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b1a7a4",
    vectorEffect: "non-scaling-stroke",
    d: "m163.25 378.39-11.35-3.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e3e1",
    vectorEffect: "non-scaling-stroke",
    d: "M151.9 374.7c-1-7.2-3.89-12.08-6.52-18.6q-.76-1.87-2.09-3.5a1.35 1.32 26 0 1-.3-.84l-.06-6.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aabbb5",
    vectorEffect: "non-scaling-stroke",
    d: "m142.93 345.49.06-51.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b2c3bd",
    vectorEffect: "non-scaling-stroke",
    d: "M142.99 294.25V179.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aabbb5",
    vectorEffect: "non-scaling-stroke",
    d: "m142.99 179.49-.29-18.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a1aeaa",
    vectorEffect: "non-scaling-stroke",
    d: "m142.7 161.43.26-19.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6a8b80",
    vectorEffect: "non-scaling-stroke",
    d: "M142.99 294.25q-1.04-.43-1.17 1.44a.22.22 0 0 1-.41.1l-.28-.46q-.19-.34-.57-.44-3.52-1.01-4.71 2.46a.42.28-49.9 0 1-.66.19q-.31-1.87-1.99-2.16-.43-.08-.62-.47-.47-.99-1.84-.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c5c9c2",
    vectorEffect: "non-scaling-stroke",
    d: "M91.69 223.64q.19.28.29.47.19.37.6.37c2.85.04 11.3 1.56 10.38-3.64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfd4cd",
    vectorEffect: "non-scaling-stroke",
    d: "m103.01 198.77.45-5.65a1.41 1.39-14.4 0 1 .65-1.08q1.22-.78 2.13.51 3.07 4.38 2.52 9.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6a8b80",
    vectorEffect: "non-scaling-stroke",
    d: "m142.99 179.49-.25 1.48q-.09.55-.65.48l-10.5-1.33q-.33-.05-.34.29 0 .19.01.39.01.22-.15.06l-.34-.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfcec9",
    vectorEffect: "non-scaling-stroke",
    d: "M56.62 425.12q.93.7 1.27 2.14.12.5.62.64 1.02.29 2.27-.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1e3e1",
    vectorEffect: "non-scaling-stroke",
    d: "M60.78 427.87c-3.91 1.4-6.47.82-9.59-2-3.17-2.87-7.3-4.84-11.03-7.19q-.42-.26-.9-.19-2.82.45-3.74-2.19-.18-.51-.68-.73c-2.53-1.1-4.83-2.47-7.47-3.31-2.11-.68-4.1-2.32-5.91-3.08q-4.71-1.97-8.89-4.89c-2.35-1.64-5.29-1.81-7.96-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0ddda",
    vectorEffect: "non-scaling-stroke",
    d: "M60.78 427.87q8.15-.72 16.44-1.81c3.21-.42 6.51-.45 9.65-1.13 2.62-.58 5.06-.2 7.69-.76 3.57-.75 6.81-.68 10.17-1.6a1.15 1.13-35.2 0 1 .94.15c.93.63 1.2.64 2.35.39q8.16-1.75 16.47-2.32c4.59-.32 9.94-1.44 15.05-1.41q.47.01.69-.4c.05-.09 30.35-3.86 32.99-4.31 2.71-.46 5.4.05 8.27-.43 5.95-.99 11.53-1.27 17.25-2.28q8.84-1.55 11.51-1.45 4.45.17 7.27-1.25.46-.24.46-.76l.01-1.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbc5cb",
    vectorEffect: "non-scaling-stroke",
    d: "M79.75 167.7c-2.04.05-9.4-1.05-8.77 2.49a1.68 1.68 0 0 0 1.59 1.38l18.06.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d5dad4",
    vectorEffect: "non-scaling-stroke",
    d: "M101.47 193.2q-.65 3.51-4.08 3.08-.51-.07-.61.43l-.35 1.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ccb1b7",
    vectorEffect: "non-scaling-stroke",
    d: "M96.43 198.52q-.23-.5-.52-.68a.12.11 37.8 0 0-.14.01l-.24.24q-.13.14-.32.14l-29.25-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d5dad4",
    vectorEffect: "non-scaling-stroke",
    d: "M65.96 197.93q-.17-2.59 1.36-2.57 5.76.11 11.57.32.33.01.39-.31l.36-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ccb1b7",
    vectorEffect: "non-scaling-stroke",
    d: "m79.64 193.54 16 .45q.49.01.64-.45.15-.46-.05-.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbc5cb",
    vectorEffect: "non-scaling-stroke",
    d: "M96.23 192.74c.79-1.58.11-2.51-1.59-2.47q-11.46.29-22.92-.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d5dad4",
    vectorEffect: "non-scaling-stroke",
    d: "m71.72 189.7 2.11-.46a.3.3 0 0 0-.01-.58l-2.34-.42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ccb1b7",
    vectorEffect: "non-scaling-stroke",
    d: "m71.48 188.24 24.23.28q.56.01.56-.55-.01-.55-.64-.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbc5cb",
    vectorEffect: "non-scaling-stroke",
    d: "M95.63 187.18q1.19-2.41-.38-2.43-14.53-.24-27.72-.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d5dad4",
    vectorEffect: "non-scaling-stroke",
    d: "M67.53 184.51q1.9-7.99-8.26-9.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0cbd0",
    vectorEffect: "non-scaling-stroke",
    d: "M67.53 184.51q-2.37-.05-1.51 2.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d1b7bc",
    vectorEffect: "non-scaling-stroke",
    d: "M66.02 187.17q2.32 1.42 5.46 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0cbd0",
    vectorEffect: "non-scaling-stroke",
    d: "M71.72 189.7c-2.36-.53-5.76-.79-6.11 2.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d1b7bc",
    vectorEffect: "non-scaling-stroke",
    d: "M65.61 192.36q5.79 2.51 14.03 1.18M65.96 197.93q.1 1.05 3.55 1.16 13.17.39 26.37.6.54.01.63-.52.05-.28-.08-.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7a2b3",
    vectorEffect: "non-scaling-stroke",
    d: "m95.63 187.18-29.61-.01M96.23 192.74c-1.02 1.04-20.14-.08-30.62-.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a37580",
    vectorEffect: "non-scaling-stroke",
    d: "m184.96 107.81 1.77.13a.41.41 0 0 0 .44-.38l.01-.18a3.51 1.23-85.9 0 0-.97-3.59l-.14-.01a3.51 1.23-85.9 0 0-1.48 3.41l-.01.18a.41.41 0 0 0 .38.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a37580",
    vectorEffect: "non-scaling-stroke",
    d: "M183.99 110.76a.84.84 0 0 0-.63.71l-1.25 9.78a.84.84 0 0 0 .99.93l6.87-1.27a.84.84 0 0 0 .68-.97l-1.66-9.48a.84.84 0 0 0-1.03-.67l-3.97.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cacec8",
    vectorEffect: "non-scaling-stroke",
    d: "M83.45 154.55a2.83 2.83 0 0 0-2.83-2.83 2.83 2.83 0 0 0-2.83 2.83 2.83 2.83 0 0 0 2.83 2.83 2.83 2.83 0 0 0 2.83-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cdcbc6",
    vectorEffect: "non-scaling-stroke",
    d: "M66.04 203.66q-.31.79 1.28.83 14.36.36 28.75.67.67.01.36-.59-.17-.31-.7-.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e0cbd0",
    vectorEffect: "non-scaling-stroke",
    d: "M95.73 204.11q1.2-.68.39-2.08a1.22 1.22 0 0 0-1.07-.6c-9.11.16-18.22-.38-27.25.02-1.43.06-2.05.8-1.76 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d3b6bd",
    vectorEffect: "non-scaling-stroke",
    d: "m95.73 204.11-29.69-.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#79635d",
    vectorEffect: "non-scaling-stroke",
    d: "M146.89 413h.63q.87 0 .15-.49-1.2-.81-2.71-.47-.46.1-.84.4-1.33 1.05-2.34-.27a.35.34 63.9 0 1 .18-.54l3.02-.81a.25.25 0 0 0 .02-.48q-.11-.05-.24-.08-.13-.02-.07-.14l.94-1.73a.85.84 9.7 0 1 .63-.44l5.81-.8a.81.81 0 0 0 .17-1.56q-1.32-.48-3.09-.03c-4.43 1.12-9.58 1.22-12.99 1.6q-21.12 2.33-42.24 4.58c-9.3.99-23.81 3.2-35.84 4.02q-.52.04-.96-.24-6.97-4.35-14.51-7.55-.23-.1-.31-.34l-.13-.36q-.09-.28-.39-.32c-2.27-.27-3.71-1.58-5.28-2.37q-11.35-5.75-22.71-11.49c-1.33-.68-3.04-2-4.97-2.29a.92.92 0 0 0-.48 1.77q.84.34 1.65.42.5.05.99.14 1.01.19 1.04.69.02.46.44.69 15.52 8.42 41.85 21.44 3.9 1.93 1.94 6.49-.24.56.23.94c1.66 1.34 4.19.37 5.77.21q26.17-2.66 52.28-5.85 12.25-1.49 24.51-3.01c2.28-.28 4.99-1.41 7.8-1.29a.07.07 0 0 0 .07-.09l-.09-.25q-.03-.1.07-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dbddda",
    vectorEffect: "non-scaling-stroke",
    d: "M221.43 415.6a1.15 1.15 0 0 0 1.65-1.58l-1.74-2.32a.7.7 0 0 0-1.26.38q-.11 2.32 1.35 3.52"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v458H0V0zm22.65.21L1.73 14.68a1.01 1-17.2 0 0-.44.83q-.04 19.25-.16 38.46c-.02 1.9-1.66 4.43.1 6.11q.36 13.13.33 26.36-.01 3.64 2.31 7.82c1.13 1.42 1.91 3.39 3.15 4.33q2.63 1.99 6.95.94l.28 3.97v272l.29 9.85a1.07 1.07 0 0 1-.96 1.1l-10.97 1.13a.96.96 0 0 0-.85.77q-1.38 6.83 1.88 8.2l.97 5 .6 5.69q.05.51.46.81 2.96 2.17 3.88 2.67 19.3 10.39 38.14 21.59 2.14 1.27 2.87 2.05.31.33.75.45l1.72.47a2.05 1.97 75.3 0 1 .9.55q1.62 1.75 4.1 1.39a1.24 1.24 0 0 0 1.02-1.54c-.95-3.52 7.68-2.84 9.48-2.78 3.08.09 4.65.77 7.72-.65a1.47 1.47 0 0 1 .97-.08c2.63.7 4.22.89 7.02-.18 1.84-.7 11.66-2.43 11.86 1.24q.03.6.61.47l3.92-.84q.45-.1.89.03 1.46.43 2.88-.28.39-.19.82-.15 1.83.18 3.65.24c3.26.11 5.16-1.61 8.93-.46a1.37 1.32-47.6 0 0 .95-.06q4.11-1.84 8.66-1.07.41.07.68.39c1.1 1.28 8.01.03 9.23-.35q.47-.14.68-.6.82-1.77 3.03-1.75 3.24.03 7.01-.91.5-.12.98.09 2.34 1.04 4.89.73.52-.06.92-.39 1.83-1.46 4.19-.57a1.44 1.42-43.9 0 0 .97.01q4.3-1.48 8.85-1.36c2.16.06 3.94-1.1 6.29-1.16q11.49-.31 22.89-1.71c1.76-.22 3.79-.05 5.7-.28 1.55-.19 2.7-1.31 4.51-1.22q.46.02.88-.17c3.69-1.66 7.47-2.3 11.37-1 3.09 1.03 10.69-.83 9.67-5.52q-.11-.51-.54-.8-2.43-1.63-5.34-1.77-.19-.01-.25.17-.06.17-.11.34a.17.17 0 0 1-.33 0q-.53-1.58-2.07-2.15-.44-.16-.66-.57-.84-1.56-.85-3.55l3.8-.66a1.07 1.07 0 0 0 .89-1.07l-.06-6.62a.91.91 0 0 0-.63-.85l-60.75-19.42q-3.91-12.32-7.59-23.98c-1.38-4.36-1.9-8.31-2.49-12.73-.51-3.8-2.08-8.94-2.07-13.68q.04-8.56-.22-17.12c-.06-1.83.31-4.32-.01-6.53q-.44-2.97-.3-4.76c.58-7.15-.38-14.87-.14-21.11.34-8.8.94-17.53.23-26.33-1.07-13.27-.28-26.69-.4-40.01-.02-2.49.7-4.94.73-7.51q.2-18.84-.13-37.69-.01-.51.24-.94 1.5-2.66 2.48-7.25c3.17-14.86 15.32-17.24 27.84-20.88q3.28 3.58 9.06 3.36c13.81 1.21 18.63-19.94 18.31-30.09l-.05-2.06q-.09-8.79-4.67-16.5l2.68-5.66 2.81.5c1.92 3.63 5.3 4.87 8.71 2.15q4.28-3.41 5.98-10.43 1.16-12.98.99-27.14-.02-1.16.48-2.63.56-.83.56-2.24c-.52-1.65-1.63-2.79-3.48-3.05q-13.08-1.89-26.41-3.33-9.59-7.93-15.57-18.76c-1.03-1.87-1.95-1.72-3.82-1.97q-28.34-3.73-56.7-7.34L22.65.21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc3d2",
    d: "M120.3 12.68q-2.43 4.41-3.97 9.11c-1.48 4.51-7.35 6.92-11.59 7.84q-.68.15 0 .3.81.19.77.45l-47.95-5.75q-.5-.06-.79.36-1.28 1.88-1.37 4.49l-5.3 3.2-2.13-.19q-.48-.04-.57-.52-.4-2.07-1.72-2.65c-7.06-3.12-10.52-5.1-14.47-11.01Q25.46 9.69 22.65.21l97.65 12.47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "M22.65.21q2.81 9.48 8.56 18.1c3.95 5.91 7.41 7.89 14.47 11.01q1.32.58 1.72 2.65.09.48.57.52l2.13.19Q27.71 44.93 5.04 56.52q-2.06 1.05-2.57 2.85l-1.24.71c-1.76-1.68-.12-4.21-.1-6.11q.12-19.21.16-38.46a1.01 1-17.2 0 1 .44-.83L22.65.21zM120.3 12.68q28.36 3.61 56.7 7.34c1.87.25 2.79.1 3.82 1.97q5.98 10.83 15.57 18.76-.13.03-.27.26-.17.3-.52.26l-90.09-10.89q.04-.26-.77-.45-.68-.15 0-.3c4.24-.92 10.11-3.33 11.59-7.84q1.54-4.7 3.97-9.11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cedc",
    d: "m105.51 30.38 90.09 10.89q.35.04.52-.26.14-.23.27-.26 13.33 1.44 26.41 3.33c1.85.26 2.96 1.4 3.48 3.05l-1.24.85a1.36 1.35 30.8 0 1-.93.23Q143.45 38.8 62.75 29.75q-1.76-.2-7.35-.27.09-2.61 1.37-4.49.29-.42.79-.36l47.95 5.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c88d9f",
    d: "M55.4 29.48q5.59.07 7.35.27 80.7 9.05 161.36 18.46a1.36 1.35 30.8 0 0 .93-.23l1.24-.85q0 1.41-.56 2.24l-26.75-2.95-25.79-2.82-28.1-3.35-28.13-3.15-29.6-3.38-29.21-3.47h-1.43a2.05 2.04-59.8 0 0-.94.25l-12.22 6.77-11 5.8-11.22 6.08-10.16 5.49-8.7 4.73q.51-1.8 2.57-2.85Q27.71 44.93 50.1 32.68l5.3-3.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6e8e8",
    d: "M58.14 30.25q-.49 1.65-.65 5.72-.67 16.7-.07 26.16-1.48 8.04-5.18 13.88c-5.37 2.66-6.42-2.42-7.79-6.61-1.44-10.38-.63-21.42-.9-32.13l12.22-6.77a2.05 2.04-59.8 0 1 .94-.25h1.43z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cedc",
    d: "m58.14 30.25 29.21 3.47v28.21c-3.38 18.96-25.32 16.12-29.93.2q-.6-9.46.07-26.16.16-4.07.65-5.72z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef5f5",
    d: "m87.35 33.72 29.6 3.38-.37 27.73c-3.47 20.42-26.87 14.89-29.23-2.9V33.72z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cedc",
    d: "m116.95 37.1 28.13 3.15-.01 25.59q-.84 13.52-13.38 14.84-12.67-2.28-15.11-15.85l.37-27.73z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "M43.55 37.27c.27 10.71-.54 21.75.9 32.13l-2.67 8.62-1.55 2.37c-4.1 4.91-7.17-3.08-7.41-6.49l-.27-30.83 11-5.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6e8e8",
    d: "m145.08 40.25 28.1 3.35-.69 27.31q-1.92 9.12-9.2 11.66-6.89 1.54-12.35-3.11-5.45-5.05-5.87-13.62l.01-25.59zM32.55 43.07l.27 30.83c-.37 4.69-6.37 22.36-10.85 6.2-.12-2.07-.72-4.1-.72-6.16q-.03-12.28.08-24.79l11.22-6.08z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc3d2",
    d: "m173.18 43.6 25.79 2.82.1 26.19q-1.23 8.55-7.64 11.75-7.17 2.79-13.66-2.88-3.96-3.94-5.28-10.57l.69-27.31z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6e8e8",
    d: "m198.97 46.42 26.75 2.95q-.5 1.47-.48 2.63.17 14.16-.99 27.14-4.72 10.21-14.69 8.28l-2.81-.5c.08-.65-.11-1.21-.69-1.62q-6.2-4.47-6.99-12.69l-.1-26.19z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "M21.33 49.15q-.11 12.51-.08 24.79c0 2.06.6 4.09.72 6.16-1.3 3.84-1.56 7.69-5.27 10.78-3.99.14-4.03-3.96-5.04-6.68l-.49-29.56 10.16-5.49z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6e8e8",
    d: "m11.17 54.64.49 29.56-1.54 5.99c-.95 2.77-2.65 5.99-6.25 4.07q-2.32-4.18-2.31-7.82.03-13.23-.33-26.36l1.24-.71 8.7-4.73z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c6d6c",
    d: "M87.35 61.93c2.36 17.79 25.76 23.32 29.23 2.9q2.44 13.57 15.11 15.85c-.27 1.15-2.03 4.3-3.46 3.21q-.35-.27-.81-.23c-5.55.46-10.51-.59-16.02-.95q-2.85-.18-5.66-.93-.5-.13-.98.06c-2.79 1.07-6.05.12-8.16.17q-6.07.13-12.14-.92-.54-.09-.94-.47-1.87-1.76-4.41-.88-.49.16-.97 0-1.54-.5-3.22-.62c-1.67-.11-3.86 1.33-5.75-.31q-.38-.33-.88-.41c-1.89-.28-3.29.24-5.18-.16q-3.83-.8-7.75-.21-.49.08-.87-.23l-2.25-1.79q3.7-5.84 5.18-13.88c4.61 15.92 26.55 18.76 29.93-.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M145.07 65.84q.42 8.57 5.87 13.62l-.18 19.36c-1.03 2.31-.69 4.67-1.67 6.83q-2.53 5.61-6.18 11.12l-.06-25.74q0-.62-.62-.69-2.47-.27-4.4-1.69-1.65-2.77-3.9-2.63-1.38.09-1.47.08-14.24-.68-28.48-1.26c-2.4-.1-4.87-1.17-7.73-1.58q-11.37-1.62-19.22-1.77c-2.26-.04-4.49-1.15-7.13-.54q-.47.11-.92-.09c-2.26-.99-6.26-.48-8.81-.65-1.69-.12-3.55-1.2-5.85-.46a1.58 1.55-43.8 0 1-.99-.01q-2.57-.85-5.25-.57-.54.06-1.02-.19-2.5-1.28-5.28-.96l2.67-8.62c1.37 4.19 2.42 9.27 7.79 6.61l2.25 1.79q.38.31.87.23 3.92-.59 7.75.21c1.89.4 3.29-.12 5.18.16q.5.08.88.41c1.89 1.64 4.08.2 5.75.31q1.68.12 3.22.62.48.16.97 0 2.54-.88 4.41.88.4.38.94.47 6.07 1.05 12.14.92c2.11-.05 5.37.9 8.16-.17q.48-.19.98-.06 2.81.75 5.66.93c5.51.36 10.47 1.41 16.02.95q.46-.04.81.23c1.43 1.09 3.19-2.06 3.46-3.21q12.54-1.32 13.38-14.84z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b717a",
    d: "M172.49 70.91q1.32 6.63 5.28 10.57l-.33 8.67q-.54 1.49-.62 3.23c-.23 5.21-7.83 14.5-11.68 5.41q-.67-1.59-1.81-2.7l-.04-13.52q7.28-2.54 9.2-11.66zM199.07 72.61q.79 8.22 6.99 12.69c.58.41.77.97.69 1.62l-2.68 5.66q-.16.43-.79.43.23-.33.17-.65-.12-.58-.57-.2l-2.42 2.03a.28.28 0 0 0 .09.48q.4.12.46.27c-4.3 2.02-7.39-2.49-8.35-6.04q-.17-.64-.58-.11-.55.75-.33 2.31-.46-.33-.93.18c-.4-2.58 2.01-5.65.61-6.92q6.41-3.2 7.64-11.75z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2f2d",
    d: "M32.82 73.9c.24 3.41 3.31 11.4 7.41 6.49q12.19.62 24.23 2.12c6.76.85 13.49 1.24 20.26 1.97q6.91.76 13.85 1.17 11.85.71 13.85.87 12.9 1.02 25.41 2.13 1.93 1.42 4.4 1.69.62.07.62.69l.06 25.74-.1 10.46c.16 2.91-.27 3.57-2.95 3.89q-4.82.59-9.18 1.99l.12-29.3a.92.91-87.7 0 0-.85-.93L30.99 95.4q-.77-.05-.56.69l.36 1.23a.56.55 78.8 0 0 .59.4c5.51-.64 11.82.48 16.05.66q8.47.36 16.89 1.4c2.53.31 5.13.12 7.75.31q28.14 2.08 56 4.29a.73.73 0 0 1 .68.73l.01 19.35q-8.81-6.59-19.24-8.96c-6.89-1.57-14.83.6-21.52-1.55-4.73-1.52-9.09.47-13.76-.94q-9.76-2.97-19.85-4.4-3.8-.54-7.22-1.85c-2.12-.82-17.07-7.24-15.16-.49a.6.6 0 0 1-.95.64l-.59-.46c1.18-5.48-4.52-5.32-7.86-6.78q-.47-.21-.74-.64l-5.17-8.15c3.71-3.09 3.97-6.94 5.27-10.78 4.48 16.16 10.48-1.51 10.85-6.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b4a43",
    d: "M41.78 78.02q2.78-.32 5.28.96.48.25 1.02.19 2.68-.28 5.25.57a1.58 1.55-43.8 0 0 .99.01c2.3-.74 4.16.34 5.85.46 2.55.17 6.55-.34 8.81.65q.45.2.92.09c2.64-.61 4.87.5 7.13.54q7.85.15 19.22 1.77c2.86.41 5.33 1.48 7.73 1.58q14.24.58 28.48 1.26.09.01 1.47-.08 2.25-.14 3.9 2.63-12.51-1.11-25.41-2.13-2-.16-13.85-.87-6.94-.41-13.85-1.17c-6.77-.73-13.5-1.12-20.26-1.97q-12.04-1.5-24.23-2.12l1.55-2.37z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#954a61",
    d: "M224.25 79.14q-1.7 7.02-5.98 10.43c-3.41 2.72-6.79 1.48-8.71-2.15q9.97 1.93 14.69-8.28z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#7d374a",
    d: "M150.94 79.46q5.46 4.65 12.35 3.11l.04 13.52c-1.11 7.81-8.92 16.58-12.57 2.73l.18-19.36z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#954a61",
    d: "M177.77 81.48q6.49 5.67 13.66 2.88c1.4 1.27-1.01 4.34-.61 6.92-1.65 4.62-5 9.51-10.55 6.59q.09-.58-.58-1.17l-2.25-6.55.33-8.67z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a4c45",
    d: "M11.66 84.2c1.01 2.72 1.05 6.82 5.04 6.68l5.17 8.15q.27.43.74.64c3.34 1.46 9.04 1.3 7.86 6.78l.26 3.22a.77.76-77.6 0 0 .38.61l.29.17q.6.36.6-.34v-2.59a.61.6-.5 0 1 .6-.6c7.18-.13 10.53 2.1 15.84 5.12q4.49 2.55 12.7 3.33c2.39.23 4.75 1.24 7.33 1.36 2.51.13 4.31 1.4 6.86 1.49 4.79.17 9.56.35 14.29 1.16q2.31.4 4.65.45c5.42.12 8.53.43 12.88.76q2.28.17 4.33 1.29 4.91 2.66 10.05 4.84c2.59 1.1 4.65 2.83 7.2 4.17l.01 13.17q-4.55-2.46-9.01-4.79-1.26-.66-3.46-2.63-3.04-2.72-7.51-2.96l-.31-8.03a1.12 1.11-89.4 0 0-1.04-1.07l-49.43-3.1-6.35-.05q-.57 0-.58.56l-.06 2.5-.55 3.12a.82.81-57.1 0 1-1.48.32q-.86-1.26-.2-2.61a1.23 1.21 47 0 0 .03-1.04q-.75-1.73-.25-3.61.14-.55-.26-.95c-3.34-3.37-10.29-8.04-15.65-7.99q-.58 0-.59.59l-.24 9.31-.13 13.36q-.47.78-1.38.44l-.05-21.36q-.01-.48-.34-.83-1.93-1.97-4.15-3.54c-3.52-2.49-5.4-4.91-8.05-8.02a1.16 1.16 0 0 0-2.04.85q.12 1.31-1.41.97l-.28-3.97q.9-4.69-3.85-9.34l1.54-5.99zM201.01 94.94q1.36-.67 2.27-1.93.63 0 .79-.43 4.58 7.71 4.67 16.5l-3.25-.4a1.1 1.08 24.2 0 0-.92.34q-2 2.21-4.59 3.01l-.13-2.33q.12-7.91-4.15-14.73c-1-1.6-2.59-2.55-3.95-3.87q-.22-1.56.33-2.31.41-.53.58.11c.96 3.55 4.05 8.06 8.35 6.04z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#969792",
    d: "M10.12 90.19q4.75 4.65 3.85 9.34-4.32 1.05-6.95-.94c-1.24-.94-2.02-2.91-3.15-4.33 3.6 1.92 5.3-1.3 6.25-4.07z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0b1ab",
    d: "m177.44 90.15 2.25 6.55q-4.26 8.12-4.48 17.39 0 .38-.38.46l-3.8.74q-.46.1-.69.51-1.89 3.43.24 6.27.33.44.89.43l2.29-.03q-3.27 2.6-4.99 2.44-11.26-1.08-20.23 1.24-3.32.85-5.58 4.55l-.15-3.47.1-10.46q3.65-5.51 6.18-11.12c.98-2.16.64-4.52 1.67-6.83 3.65 13.85 11.46 5.08 12.57-2.73q1.14 1.11 1.81 2.7c3.85 9.09 11.45-.2 11.68-5.41q.08-1.74.62-3.23z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#b09f9f",
    d: "M191.75 91.1c1.36 1.32 2.95 2.27 3.95 3.87q4.27 6.82 4.15 14.73c-5.22 1.39-3.04 5.84-8.07 7.24q-.43-6.76-3.56-14.35a1.85 1.85 0 0 0-2.9-.71q-2.5 2.09-2.72 5.85c-.08 1.3-1.05 2.27-1.25 3.57q-.95 6.28-1.03 13.15-3.09-2-3.43.47l-.59-2.94q-1.54-12.62 3.97-24.11c5.55 2.92 8.9-1.97 10.55-6.59q.47-.51.93-.18z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0b5b3",
    d: "M203.28 93.01q-.91 1.26-2.27 1.93-.06-.15-.46-.27a.28.28 0 0 1-.09-.48l2.42-2.03q.45-.38.57.2.06.32-.17.65z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d1412",
    d: "m130.68 133.11.07 9.43-.01 14.18q-.83.81-1.99.72l-.01-13.38-.01-13.17.03-6.43-.01-19.35a.73.73 0 0 0-.68-.73q-27.86-2.21-56-4.29c-2.62-.19-5.22 0-7.75-.31q-8.42-1.04-16.89-1.4c-4.23-.18-10.54-1.3-16.05-.66a.56.55 78.8 0 1-.59-.4l-.36-1.23q-.21-.74.56-.69l98.96 7.48a.92.91-87.7 0 1 .85.93l-.12 29.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a4c45",
    d: "M179.69 96.7q.67.59.58 1.17-5.51 11.49-3.97 24.11-1.2.6-1.59-.28-.19-.42-.57-.15-.31.24-.38.92l-2.29.03q-.56.01-.89-.43-2.13-2.84-.24-6.27.23-.41.69-.51l3.8-.74q.38-.08.38-.46.22-9.27 4.48-17.39z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#719387",
    d: "m30.29 135.43-.39 1.65q-1.62-1.29-2.64-3.18c-2.14-3.99-4.75-6.16-5.47-11.03q-.07-.5-.42-.85c-2.38-2.44-.97-6.27-4.17-7.78q-.46-.22-.45.29c.2 12.72.57 26.3.49 38.19q-.4 61.12-.2 122.31-.06 21.03-.05 42.1c.01 10.13-.92 21.6-1 32.45-.01 1.12.62 2.26 1.08 3.19a.84.83 43.4 0 0 1.52-.04q1.41-3.31 2.14-6.23c1.21-4.85 3.72-8.51 6.04-12.73q.66-1.2 2.67-.72.59.14.61-.47l.24-8.59.01 47.81q-5.75 3.21-8.52 6.99-2.55 3.49-5.66 4.49c0-.05-.54-9.3-1.87-7.78v-272q1.53.34 1.41-.97a1.16 1.16 0 0 1 2.04-.85c2.65 3.11 4.53 5.53 8.05 8.02q2.22 1.57 4.15 3.54.33.35.34.83l.05 21.36z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#954a61",
    d: "M191.78 116.94q.79 2.99.35 4.99-.12.52-.65.62l-11.16 1.9q.08-6.87 1.03-13.15c.2-1.3 1.17-2.27 1.25-3.57q.22-3.76 2.72-5.85a1.85 1.85 0 0 1 2.9.71q3.13 7.59 3.56 14.35zm-6.82-9.13 1.77.13a.41.41 0 0 0 .44-.38l.01-.18a3.51 1.23-85.9 0 0-.97-3.59l-.14-.01a3.51 1.23-85.9 0 0-1.48 3.41l-.01.18a.41.41 0 0 0 .38.44zm-.97 2.95a.84.84 0 0 0-.63.71l-1.25 9.78a.84.84 0 0 0 .99.93l6.87-1.27a.84.84 0 0 0 .68-.97l-1.66-9.48a.84.84 0 0 0-1.03-.67l-3.97.97z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#303b37",
    d: "m128.76 124.46-.03 6.43c-2.55-1.34-4.61-3.07-7.2-4.17q-5.14-2.18-10.05-4.84-2.05-1.12-4.33-1.29c-4.35-.33-7.46-.64-12.88-.76q-2.34-.05-4.65-.45c-4.73-.81-9.5-.99-14.29-1.16-2.55-.09-4.35-1.36-6.86-1.49-2.58-.12-4.94-1.13-7.33-1.36q-8.21-.78-12.7-3.33c-5.31-3.02-8.66-5.25-15.84-5.12a.61.6-.5 0 0-.6.6v2.59q0 .7-.6.34l-.29-.17a.77.76-77.6 0 1-.38-.61l-.26-3.22.59.46a.6.6 0 0 0 .95-.64c-1.91-6.75 13.04-.33 15.16.49q3.42 1.31 7.22 1.85 10.09 1.43 19.85 4.4c4.67 1.41 9.03-.58 13.76.94 6.69 2.15 14.63-.02 21.52 1.55q10.43 2.37 19.24 8.96z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#b09f9f",
    d: "M184.96 107.81a.41.41 0 0 1-.38-.44l.01-.18a3.51 1.23-85.9 0 1 1.48-3.41l.14.01a3.51 1.23-85.9 0 1 .97 3.59l-.01.18a.41.41 0 0 1-.44.38l-1.77-.13z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#506a61",
    d: "m208.74 109.08.05 2.06q.09.93-.37 1.51a.75.74-59.2 0 1-.86.22c-3.83-1.55-5.49.05-6.09 3.8-1.19 7.45-3.99 15.61-10.26 20.4-1.58 1.2-1.84 2.59-.73 4.16q-5.78.22-9.06-3.36-3.05-3.22-4.64-8l-2-7.26q-.15-.55-.67-.3l-.35.16q.07-.68.38-.92.38-.27.57.15.39.88 1.59.28l.59 2.94c1.5 6.85 7.44 16.76 15.48 9.37 5.38-4.93 7.65-15.09 7.61-22.26q2.59-.8 4.59-3.01a1.1 1.08 24.2 0 1 .92-.34l3.25.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0b5b3",
    d: "m199.85 109.7.13 2.33c.04 7.17-2.23 17.33-7.61 22.26-8.04 7.39-13.98-2.52-15.48-9.37q.34-2.47 3.43-.47l11.16-1.9q.53-.1.65-.62.44-2-.35-4.99c5.03-1.4 2.85-5.85 8.07-7.24z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#b09f9f",
    d: "m183.99 110.76 3.97-.97a.84.84 0 0 1 1.03.67l1.66 9.48a.84.84 0 0 1-.68.97l-6.87 1.27a.84.84 0 0 1-.99-.93l1.25-9.78a.84.84 0 0 1 .63-.71z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#628378",
    d: "M208.79 111.14c.32 10.15-4.5 31.3-18.31 30.09-1.11-1.57-.85-2.96.73-4.16 6.27-4.79 9.07-12.95 10.26-20.4.6-3.75 2.26-5.35 6.09-3.8a.75.74-59.2 0 0 .86-.22q.46-.58.37-1.51z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#506a61",
    d: "m50.99 124.49.02 16.06-.09 1.92c-.25 1.71-.01 6.38-2.17 6.5l-.26-14.63q-.01-.44-.37-.67c-2.42-1.58-4.17-4.21-6.23-5.63q-4.74-3.27-10.09-6.41l.24-9.31q.01-.59.59-.59c5.36-.05 12.31 4.62 15.65 7.99q.4.4.26.95-.5 1.88.25 3.61a1.23 1.21 47 0 1-.03 1.04q-.66 1.35.2 2.61a.82.81-57.1 0 0 1.48-.32l.55-3.12z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#80a095",
    d: "M29.9 137.08 30.07 257l-2.69 4.07q-.28.43-.8.43h-.48q-.47 0-.66.43-1.64 3.85-3.27 7.69c-1.15 2.73-1.83 5.79-5.13 5.41q-.2-61.19.2-122.31c.08-11.89-.29-25.47-.49-38.19q-.01-.51.45-.29c3.2 1.51 1.79 5.34 4.17 7.78q.35.35.42.85c.72 4.87 3.33 7.04 5.47 11.03q1.02 1.89 2.64 3.18z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0b1ab",
    d: "m57.98 121.48 1.04.31q.46.14.65.59c.8 1.92 10.43 3.38 13.03 4.39q6.25 2.43 21.8 4.67 12.17 1.75 14.04 11.33l.26 7.02.17 28.76-.04 5.18q-1.99-7.47-1.69-15.68c.09-2.41-2.47-3.62-4.25-1.5l-.56-10c-1.42-2.16-6.59-1.64-9.29-1.4q-2.11.19-2.28-1.93c-.73-9.06-12.13-13.39-18.12-6.04l-.87 1.54q-9.82-5.43-20.86-8.17l-.02-16.06.06-2.5q.01-.56.58-.56l6.35.05z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#969792",
    d: "m57.98 121.48 49.43 3.1a1.12 1.11-89.4 0 1 1.04 1.07l.31 8.03-.22 9.09q-1.87-9.58-14.04-11.33-15.55-2.24-21.8-4.67c-2.6-1.01-12.23-2.47-13.03-4.39q-.19-.45-.65-.59l-1.04-.31z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a8c81",
    d: "m48.75 148.97-.02 18.56q-3.91-3.03-6.08-7.37c-1.46-2.93-4.79-7.8-7.12-10.01q-1.47-1.4-3.11-3.46a.21.21 0 0 0-.38.12l-.5 6.7.13-18.52.13-13.36q5.35 3.14 10.09 6.41c2.06 1.42 3.81 4.05 6.23 5.63q.36.23.37.67l.26 14.63z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d4cf",
    d: "M176.78 129.87q-1.42.98-2.92.91-.49-.02-.86.28c-1.57 1.29-3.87.7-4.9 1.65q-.37.34-.87.39-13.35 1.26-24.27 8.57l-.1-4.24.1-6.73q2.26-3.7 5.58-4.55 8.97-2.32 20.23-1.24 1.72.16 4.99-2.44l.35-.16q.52-.25.67.3l2 7.26z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a4c45",
    d: "m142.81 127.23.15 3.47-.1 6.73q.28 3.06-.79 4.4-.35.43-.9.44l-10.42.27-.07-9.43q4.36-1.4 9.18-1.99c2.68-.32 3.11-.98 2.95-3.89z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M176.78 129.87q1.59 4.78 4.64 8c-12.52 3.64-24.67 6.02-27.84 20.88q-.98 4.59-2.48 7.25-.25.43-.24.94.33 18.85.13 37.69c-.03 2.57-.75 5.02-.73 7.51.12 13.32-.67 26.74.4 40.01.71 8.8.11 17.53-.23 26.33-.24 6.24.72 13.96.14 21.11q-.14 1.79.3 4.76c.32 2.21-.05 4.7.01 6.53q.26 8.56.22 17.12c-.01 4.74 1.56 9.88 2.07 13.68.59 4.42 1.11 8.37 2.49 12.73q3.68 11.66 7.59 23.98l-11.35-3.69c-1-7.2-3.89-12.08-6.52-18.6q-.76-1.87-2.09-3.5a1.35 1.32 26 0 1-.3-.84l-.06-6.27.06-51.24V179.49l-.29-18.06.26-19.76q10.92-7.31 24.27-8.57.5-.05.87-.39c1.03-.95 3.33-.36 4.9-1.65q.37-.3.86-.28 1.5.07 2.92-.91z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#506a61",
    d: "M108.76 133.68q4.47.24 7.51 2.96 2.2 1.97 3.46 2.63 4.46 2.33 9.01 4.79l.01 13.38v7.46q-1.5-2.56-2.78-3.13c-4.26-1.91-8.32-3.51-11.72-6.98q-2.61-2.66-5.45-5l-.26-7.02.22-9.09zM31.67 134.99l-.13 18.52.39 132.7-.15 40.84-.12 30.44-.18 19-.9-.03-.28-4.66-.01-47.81-.22-66.99-.17-119.92.39-1.65q.91.34 1.38-.44zM142.86 137.43l.1 4.24-.26 19.76-.59 1.55a.59.58 23.8 0 1-.81.31q-2.31-1.2-4.6-.03-.48.24-1.01.24h-4.93l-.02-6.78.01-14.18 10.42-.27q.55-.01.9-.44 1.07-1.34.79-4.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4c8c1",
    d: "m71.87 148.72-1.25 4.03q-.15.5-.67.57c-4.52.57-12.65-2.62-11.7 5.78q-3.46.81-6.61-.11-.45-.13-.54.33l-.31 1.69.13-18.54.09-1.92q11.04 2.74 20.86 8.17z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#628378",
    d: "m50.92 142.47-.13 18.54.09 109.16-.65 1.25a.61.6 58.7 0 1-1.14-.28l-.36-103.61.02-18.56c2.16-.12 1.92-4.79 2.17-6.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4c8c1",
    d: "M102.43 156.55q-.22-.04-.39-.05-.46-.04-.46.42l-.14 15.33-.19-.36q-.32-.59-.26.08.01.14.01.29-.01.39-.4.41l-6.19.35a1.19 1.18 63.8 0 1-.86-.3q-1.44-1.24-2.92-.53 1.91-1.8.16-3.75a1.25 1.23-19.5 0 0-.88-.41l-10.16-.33c2.47-3.54-.52-5.58-2.59-7.98q-.35-.41-.87-.55-2.64-.74-4.09-2.96-.39-.59-1.1-.56l-8.92.38a.58.57 24.8 0 1-.38-1.03l.73-.56 8.34.23a.94.94 0 0 0 .95-1.08q-.44-2.87 1.38-5.35.73-1-.46-1.06c5.99-7.35 17.39-3.02 18.12 6.04q.17 2.12 2.28 1.93c2.7-.24 7.87-.76 9.29 1.4zm-18.98-2a2.83 2.83 0 0 0-2.83-2.83 2.83 2.83 0 0 0-2.83 2.83 2.83 2.83 0 0 0 2.83 2.83 2.83 2.83 0 0 0 2.83-2.83z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#80a095",
    d: "m48.73 167.53.36 103.61a.61.6 58.7 0 0 1.14.28l.65-1.25 57.2-1.53q.59-.01.59-.6l.09-65.8.26-3.69q1.26-2.1.58-4.98a1.41 1.41 0 0 1 1.87-1.65l1.77.67a.7.7 0 0 1 .46.66l.06 77.17q-.21.31-.29.99-.06.53-.59.54-19.79.54-39.56 1.23-2.48.09-5.49 2.12c-3.05 2.05-9.45 3.19-12.87 4.15q-3.54 1-7.21 1.52-.48.07-.85.37-2.46 1.98-5.24 3.5c-2.65 1.45-3.35 3.89-7.31 3.29a.87.86 24 0 0-.79.3q-.51.63-.64 1.42a.02.01-57.4 0 1-.03.01l-.18-.35q-.12-.22-.16.03-.05.25-.15.47a.1.1 0 0 1-.19-.04l-.28-3.76-.39-132.7.5-6.7a.21.21 0 0 1 .38-.12q1.64 2.06 3.11 3.46c2.33 2.21 5.66 7.08 7.12 10.01q2.17 4.34 6.08 7.37z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M72.74 147.18q1.19.06.46 1.06-1.82 2.48-1.38 5.35a.94.94 0 0 1-.95 1.08l-8.34-.23q-3.28-.81-3.28 2.06-.02 9.36.02 18.35l-.11 45.36a1.73 1.73 0 0 0 1.55 1.73l8.77.93a2.54 2.54 0 0 1 2.28 2.46c.3 10.22 17.33 11.76 18.17-.97A1.47 1.45 88.4 0 1 91.2 223q3.51-.46 7.2-.08a2.82 2.82 0 0 0 3.11-2.81l-.04-26.91-.03-20.95.14-15.33q0-.46.46-.42.17.01.39.05l.56 10 .02 32.22-.05 22.07q-.45 4.81-11.27 2.8-.36.53-.67 1.04-.28.46-.42 1.12-2.09 9.87-10.98 8.63c-4.92-.69-7.92-5.3-9.16-9.74q-.15-.53-.7-.55l-9.45-.38a2.19 2.19 0 0 1-2.11-2.19l.05-62.47c-.95-8.4 7.18-5.21 11.7-5.78q.52-.07.67-.57l1.25-4.03.87-1.54z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#628378",
    d: "M108.8 149.79q2.84 2.34 5.45 5c3.4 3.47 7.46 5.07 11.72 6.98q1.28.57 2.78 3.13l-.02 46.11-.46-6.02q-.02-.18-.19-.22-.15-.04-.26-.1-.34-.17-.44-.53-2.96-11.1-12.15-17.8-.4-.3-.44-.8c-.22-2.95-.56-8.07-3.83-9.34q-.5-.19-.7.31-.44 1.16-1.29 2.04l-.17-28.76z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#d0d4cf",
    cx: 80.62,
    cy: 154.55,
    r: 2.83
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d4cf",
    d: "m62.53 154.44-.73.56a.58.57 24.8 0 0 .38 1.03l8.92-.38q.71-.03 1.1.56 1.45 2.22 4.09 2.96.52.14.87.55c2.07 2.4 5.06 4.44 2.59 7.98-2.04.05-9.4-1.05-8.77 2.49a1.68 1.68 0 0 0 1.59 1.38l18.06.62q1.48-.71 2.92.53a1.19 1.18 63.8 0 0 .86.3l6.19-.35q.39-.02.4-.41 0-.15-.01-.29-.06-.67.26-.08l.19.36.03 20.95q-.65 3.51-4.08 3.08-.51-.07-.61.43l-.35 1.81q-.23-.5-.52-.68a.12.11 37.8 0 0-.14.01l-.24.24q-.13.14-.32.14l-29.25-.3q-.17-2.59 1.36-2.57 5.76.11 11.57.32.33.01.39-.31l.36-1.83 16 .45q.49.01.64-.45.15-.46-.05-.8c.79-1.58.11-2.51-1.59-2.47q-11.46.29-22.92-.57l2.11-.46a.3.3 0 0 0-.01-.58l-2.34-.42 24.23.28q.56.01.56-.55-.01-.55-.64-.79 1.19-2.41-.38-2.43-14.53-.24-27.72-.24 1.9-7.99-8.26-9.66-.04-8.99-.02-18.35 0-2.87 3.28-2.06z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a4c45",
    d: "m130.74 156.72.02 6.78.01 17c-.05 24.25-.71 48.83.31 73.04.3 7.12-.29 17.14-.31 21.36q-.05 9.67-.03 19.36l-.05 73.31q0 .29-.14.55-.09.16-.12.37l-1.77-.04.15-99.41q0-.49-.45-.72c-2.19-1.08-5.35-.21-6.03-3.31a1.14 1.13 6.8 0 0-.61-.77q-.66-.31-.87-1.14-.12-.51.33-.77 1.15-.66 3.52 0c5.45-.14 5.98-5.16 4.01-9.06l.02-42.26.02-46.11v-7.46q1.16.09 1.99-.72z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#dae0d9",
    d: "m58.25 159.1-.05 62.47a2.19 2.19 0 0 0 2.11 2.19l9.45.38q.55.02.7.55c1.24 4.44 4.24 9.05 9.16 9.74q8.89 1.24 10.98-8.63.14-.66.42-1.12.31-.51.67-1.04.19.28.29.47.19.37.6.37c2.85.04 11.3 1.56 10.38-3.64l.05-22.07.45-5.65a1.41 1.39-14.4 0 1 .65-1.08q1.22-.78 2.13.51 3.07 4.38 2.52 9.69l-.09 65.8q0 .59-.59.6l-57.2 1.53-.09-109.16.31-1.69q.09-.46.54-.33 3.15.92 6.61.11z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#628378",
    d: "m142.7 161.43.29 18.06-.25 1.48q-.09.55-.65.48l-10.5-1.33q-.33-.05-.34.29 0 .19.01.39.01.22-.15.06l-.34-.36-.01-17h4.93q.53 0 1.01-.24 2.29-1.17 4.6.03a.59.58 23.8 0 0 .81-.31l.59-1.55z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4c8c1",
    d: "m108.93 183.73.09 14.82-.26 3.69q.55-5.31-2.52-9.69-.91-1.29-2.13-.51a1.41 1.39-14.4 0 0-.65 1.08l-.45 5.65-.02-32.22c1.78-2.12 4.34-.91 4.25 1.5q-.3 8.21 1.69 15.68z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "m79.75 167.7 10.16.33a1.25 1.23-19.5 0 1 .88.41q1.75 1.95-.16 3.75l-18.06-.62a1.68 1.68 0 0 1-1.59-1.38c-.63-3.54 6.73-2.44 8.77-2.49z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#dae0d9",
    d: "M59.27 174.85q10.16 1.67 8.26 9.66-2.37-.05-1.51 2.66 2.32 1.42 5.46 1.07l2.34.42a.3.3 0 0 1 .01.58l-2.11.46c-2.36-.53-5.76-.79-6.11 2.66q5.79 2.51 14.03 1.18l-.36 1.83q-.06.32-.39.31-5.81-.21-11.57-.32-1.53-.02-1.36 2.57.1 1.05 3.55 1.16 13.17.39 26.37.6.54.01.63-.52.05-.28-.08-.65l.35-1.81q.1-.5.61-.43 3.43.43 4.08-3.08l.04 26.91a2.82 2.82 0 0 1-3.11 2.81q-3.69-.38-7.2.08a1.47 1.45 88.4 0 0-1.27 1.36c-.84 12.73-17.87 11.19-18.17.97a2.54 2.54 0 0 0-2.28-2.46l-8.77-.93a1.73 1.73 0 0 1-1.55-1.73l.11-45.36zm6.77 28.81q-.31.79 1.28.83 14.36.36 28.75.67.67.01.36-.59-.17-.31-.7-.46 1.2-.68.39-2.08a1.22 1.22 0 0 0-1.07-.6c-9.11.16-18.22-.38-27.25.02-1.43.06-2.05.8-1.76 2.21z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#719387",
    d: "m128.73 211.01-.02 42.26c-3.41-1.85-12.51-3.37-12.37 3.29q.07 3.71 3.43 4.92-.78 2.56 2.9 6.95.33.39.78.6 1.75.84 3.2 2.11.38.33.52.82c.58 2.1 1.33 3.92 1.34 6.12q0 4.9-.02 9.84a.19.19 0 0 1-.35.1l-.15-.25a.6.6 0 0 0-1.12.31c.02 7.16.87 14.72-1.39 21.17-.76 2.18-.54 3.98-1.09 6.16q-.54 2.19-.52 4.26.07 4.86-2.03 9.38-1.86 4.01-4.35 7.67-.24.35-.57.64-1.33 1.18-2.13.32-.6-.65-.7.23l-.58 5.37-.01-14.28q0-.59-.52-.31c-1.51.8-1.03 17.93-1.01 20.59q.01.52-.4.84-.76.63-1.57-.4l.06-52.41a.36.36 0 0 0-.62-.26q-1.53 1.55-1.33 3.78.04.44-.1.86-.83 2.42-2.89 3.81-.46.31-.56.86l-.82 4.78q-.09.52-.59.33-1.21-.45-2.38.68-.34.32-.58.73-1.71 2.88-5.07 2.16-.64-.14-1.18.21l-5.42 3.48a1.74 1.7-59.2 0 1-1.02.27q-1.64-.09-2.94.82-.43.29-.59.79c-1.58 4.86-6.73 3.56-10.51 3.66a1.19 1.19 0 0 0-1.01.59l-.89 1.52q-.31.52-.15 1.11.59 2.18-1.42 2.85-.53.18-1.06 0-3.23-1.11-5.57 1.11-.41.39-.98.43-2.71.21-5.45.18-.53 0-.71.49l-.53 1.39a1.34 1.33 53.1 0 1-2.58-.37l-.3-3.8q-.04-.52-.56-.56-.93-.07-1.23-2.25l-.07-30.35q0-.63.62-.65l57.71-2.22q.63-.03.87-.61.31-.76 1.15-.92a.59.59 0 0 1 .7.58v1.14q0 1.54.2.01.18-1.41.12-2.83-.02-.5-.52-.49l-27.34.93q1.91-.4 2.98-1.25.1-.07.16-.18.28-.47-.24-.34a.21.21 0 0 1-.19-.36q1.2-1.02 2.56-.46.56.23.77-.34c1.95-5.27 5.07-2.79 8.71-4.5q1.63-.77 3.05-1.93.41-.35.93-.2c4.94 1.4 5.15-4.86 9.38-2.89a.94.94 0 0 0 1.33-.87l-.14-7.81-.06-77.17a.7.7 0 0 0-.46-.66l-1.77-.67a1.41 1.41 0 0 0-1.87 1.65q.68 2.88-.58 4.98l-.09-14.82.04-5.18q.85-.88 1.29-2.04.2-.5.7-.31c3.27 1.27 3.61 6.39 3.83 9.34q.04.5.44.8 9.19 6.7 12.15 17.8.1.36.44.53.11.06.26.1.17.04.19.22l.46 6.02zM142.99 179.49v114.76q-1.04-.43-1.17 1.44a.22.22 0 0 1-.41.1l-.28-.46q-.19-.34-.57-.44-3.52-1.01-4.71 2.46a.42.28-49.9 0 1-.66.19q-.31-1.87-1.99-2.16-.43-.08-.62-.47-.47-.99-1.84-.65-.02-9.69.03-19.36c.02-4.22.61-14.24.31-21.36-1.02-24.21-.36-48.79-.31-73.04l.34.36q.16.16.15-.06-.01-.2-.01-.39.01-.34.34-.29l10.5 1.33q.56.07.65-.48l.25-1.48z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "M67.53 184.51q13.19 0 27.72.24 1.57.02.38 2.43l-29.61-.01q-.86-2.71 1.51-2.66z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#c88d9f",
    d: "M95.63 187.18q.63.24.64.79 0 .56-.56.55l-24.23-.28q-3.14.35-5.46-1.07l29.61.01z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "M71.72 189.7q11.46.86 22.92.57c1.7-.04 2.38.89 1.59 2.47-1.02 1.04-20.14-.08-30.62-.38.35-3.45 3.75-3.19 6.11-2.66z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#c88d9f",
    d: "M96.23 192.74q.2.34.05.8-.15.46-.64.45l-16-.45q-8.24 1.33-14.03-1.18c10.48.3 29.6 1.42 30.62.38zM65.96 197.93l29.25.3q.19 0 .32-.14l.24-.24a.12.11 37.8 0 1 .14-.01q.29.18.52.68.13.37.08.65-.09.53-.63.52-13.2-.21-26.37-.6-3.45-.11-3.55-1.16z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6b6c6",
    d: "m95.73 204.11-29.69-.45c-.29-1.41.33-2.15 1.76-2.21 9.03-.4 18.14.14 27.25-.02a1.22 1.22 0 0 1 1.07.6q.81 1.4-.39 2.08z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0b5b3",
    d: "m66.04 203.66 29.69.45q.53.15.7.46.31.6-.36.59-14.39-.31-28.75-.67-1.59-.04-1.28-.83z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0b1ab",
    d: "M102.96 220.84c.92 5.2-7.53 3.68-10.38 3.64q-.41 0-.6-.37-.1-.19-.29-.47 10.82 2.01 11.27-2.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#80a095",
    d: "M128.71 253.27c1.97 3.9 1.44 8.92-4.01 9.06q-3.78-1.83-5.01-5.13-.29-.77-.41.04-.21 1.46.49 4.24-3.36-1.21-3.43-4.92c-.14-6.66 8.96-5.14 12.37-3.29z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#628378",
    d: "M124.7 262.33q-2.37-.66-3.52 0-.45.26-.33.77.21.83.87 1.14a1.14 1.13 6.8 0 1 .61.77c.68 3.1 3.84 2.23 6.03 3.31q.45.23.45.72l-.15 99.41q-.99.68-1.67.74-47.14 4.41-94.33 8.25c-.57.04-1.55-.21-1.18-.95l.18-19 .38 3.98q.05.46.41.17c1.54-1.24 4.11-.11 5.8-.39q4.24-.69 10.24-2.9.47-.17.95-.06 2.89.65 5.54-.2.99-1.01 3.27-1 7.73.07 18.96-1.03c12.21-1.19 23.77-1.77 35.65-3.04a.64.63-2.6 0 0 .57-.62l.08-9.12.58-5.37q.1-.88.7-.23.8.86 2.13-.32.33-.29.57-.64 2.49-3.66 4.35-7.67 2.1-4.52 2.03-9.38-.02-2.07.52-4.26c.55-2.18.33-3.98 1.09-6.16 2.26-6.45 1.41-14.01 1.39-21.17a.6.6 0 0 1 1.12-.31l.15.25a.19.19 0 0 0 .35-.1q.02-4.94.02-9.84c-.01-2.2-.76-4.02-1.34-6.12q-.14-.49-.52-.82-1.45-1.27-3.2-2.11-.45-.21-.78-.6-3.68-4.39-2.9-6.95-.7-2.78-.49-4.24.12-.81.41-.04 1.23 3.3 5.01 5.13z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#78998e",
    d: "m30.07 257 .22 66.99-.24 8.59q-.02.61-.61.47-2.01-.48-2.67.72c-2.32 4.22-4.83 7.88-6.04 12.73q-.73 2.92-2.14 6.23a.84.83 43.4 0 1-1.52.04c-.46-.93-1.09-2.07-1.08-3.19.08-10.85 1.01-22.32 1-32.45q-.01-21.07.05-42.1c3.3.38 3.98-2.68 5.13-5.41q1.63-3.84 3.27-7.69.19-.43.66-.43h.48q.52 0 .8-.43l2.69-4.07zM113.76 270.42l.14 7.81a.94.94 0 0 1-1.33.87c-4.23-1.97-4.44 4.29-9.38 2.89q-.52-.15-.93.2-1.42 1.16-3.05 1.93c-3.64 1.71-6.76-.77-8.71 4.5q-.21.57-.77.34-1.36-.56-2.56.46a.21.21 0 0 0 .19.36q.52-.13.24.34-.06.11-.16.18-1.07.85-2.98 1.25l-35.28 1.28a.41.41 0 0 0-.28.7l.32.32q.17.17.17.41l-.38 17.48-1.5 10.72q-.07.47-.46.2c-.68-.49-4 2.1-5.46 3.15-2.86 2.06-5.88 1.31-8.45-.58q-.41-.31-.62.16l-.74 1.66.15-40.84.28 3.76a.1.1 0 0 0 .19.04q.1-.22.15-.47.04-.25.16-.03l.18.35a.02.01-57.4 0 0 .03-.01q.13-.79.64-1.42a.87.86 24 0 1 .79-.3c3.96.6 4.66-1.84 7.31-3.29q2.78-1.52 5.24-3.5.37-.3.85-.37 3.67-.52 7.21-1.52c3.42-.96 9.82-2.1 12.87-4.15q3.01-2.03 5.49-2.12 19.77-.69 39.56-1.23.53-.01.59-.54.08-.68.29-.99z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#506a61",
    d: "M51.02 326.96q0 13.01-.32 25.94c-.02 1-.49 1.27-1.41 1.35q.67-21.27-.28-42.51l.38-17.48q0-.24-.17-.41l-.32-.32a.41.41 0 0 1 .28-.7l35.28-1.28 27.34-.93q.5-.01.52.49.06 1.42-.12 2.83-.2 1.53-.2-.01v-1.14a.59.59 0 0 0-.7-.58q-.84.16-1.15.92-.24.58-.87.61l-57.71 2.22q-.62.02-.62.65l.07 30.35z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#628378",
    d: "M130.74 294.26q1.37-.34 1.84.65.19.39.62.47 1.68.29 1.99 2.16a.42.28-49.9 0 0 .66-.19q1.19-3.47 4.71-2.46.38.1.57.44l.28.46a.22.22 0 0 0 .41-.1q.13-1.87 1.17-1.44l-.06 51.24.15 28.48q0 .46.46.52l.71.09q-.19-.04-.37-.08-3.87 3.45-9.8 2.62a.61.61 0 0 1-.52-.57l-.2-3.52a.62.61-15.3 0 0-.9-.51c-1.66.84.46 2.84-1 4.53l-101.97 9.37q-.47.42-1.02.56l-10.11.95a.93.92-21.5 0 1-.82-.35q-1.16-1.51-1.42-4.3 3.11-1 5.66-4.49 2.77-3.78 8.52-6.99l.28 4.66q-.41 3.64.67 2.82-1 1.35-1.04 2.41-.02.56.52.38c1.19-.41 2.42-.87 3.72-.93 11.41-.54 22.96-2.42 33.95-3.1 8.99-.56 14.72-1.64 22.04-1.98q6.31-.3 7.62-.46 15.09-1.9 29.89-2.54a1.31 1.3 19.3 0 0 .9-.43q1.69-1.92-.86-1.67l2.19-.43a.63.62 79.5 0 0 .49-.72l-.24-1.32q.03-.21.12-.37.14-.26.14-.55l.05-73.31z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a8c81",
    d: "m110 349.72-58.7 4.38a.62.62 0 0 0-.57.57q-.1 1.31-.64 2.13c-2.05-.04-1.08-1.52-.8-2.55.92-.08 1.39-.35 1.41-1.35q.32-12.93.32-25.94.3 2.18 1.23 2.25.52.04.56.56l.3 3.8a1.34 1.33 53.1 0 0 2.58.37l.53-1.39q.18-.49.71-.49 2.74.03 5.45-.18.57-.04.98-.43 2.34-2.22 5.57-1.11.53.18 1.06 0 2.01-.67 1.42-2.85-.16-.59.15-1.11l.89-1.52a1.19 1.19 0 0 1 1.01-.59c3.78-.1 8.93 1.2 10.51-3.66q.16-.5.59-.79 1.3-.91 2.94-.82a1.74 1.7-59.2 0 0 1.02-.27l5.42-3.48q.54-.35 1.18-.21 3.36.72 5.07-2.16.24-.41.58-.73 1.17-1.13 2.38-.68.5.19.59-.33l.82-4.78q.1-.55.56-.86 2.06-1.39 2.89-3.81.14-.42.1-.86-.2-2.23 1.33-3.78a.36.36 0 0 1 .62.26l-.06 52.41z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#719387",
    d: "M49.01 311.74q.95 21.24.28 42.51c-.28 1.03-1.25 2.51.8 2.55q-.2.46-.05.79.22.46.72.47l4.22.03q-2.65.85-5.54.2-.48-.11-.95.06-6 2.21-10.24 2.9c-1.69.28-4.26-.85-5.8.39q-.36.29-.41-.17l-.38-3.98.12-30.44.74-1.66q.21-.47.62-.16c2.57 1.89 5.59 2.64 8.45.58 1.46-1.05 4.78-3.64 5.46-3.15q.39.27.46-.2l1.5-10.72z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#78998e",
    d: "m113.51 343.28-.08 9.12a.64.63-2.6 0 1-.57.62c-11.88 1.27-23.44 1.85-35.65 3.04q-11.23 1.1-18.96 1.03-2.28-.01-3.27 1l-4.22-.03q-.5-.01-.72-.47-.15-.33.05-.79.54-.82.64-2.13a.62.62 0 0 1 .57-.57l58.7-4.38q.81 1.03 1.57.4.41-.32.4-.84c-.02-2.66-.5-19.79 1.01-20.59q.52-.28.52.31l.01 14.28z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d4cf",
    d: "m142.93 345.49.06 6.27a1.35 1.32 26 0 0 .3.84q1.33 1.63 2.09 3.5c2.63 6.52 5.52 11.4 6.52 18.6l-7.65-.12-.71-.09q-.46-.06-.46-.52l-.15-28.48z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#303b37",
    d: "m128.66 368.45 1.77.04.24 1.32a.63.62 79.5 0 1-.49.72l-2.19.43-96.74 8.32q-1.08.82-.67-2.82l.9.03c-.37.74.61.99 1.18.95q47.19-3.84 94.33-8.25.68-.06 1.67-.74z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#78998e",
    d: "M127.99 370.96q2.55-.25.86 1.67a1.31 1.3 19.3 0 1-.9.43q-14.8.64-29.89 2.54-1.31.16-7.62.46c-7.32.34-13.05 1.42-22.04 1.98-10.99.68-22.54 2.56-33.95 3.1-1.3.06-2.53.52-3.72.93q-.54.18-.52-.38.04-1.06 1.04-2.41l96.74-8.32z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b4a43",
    d: "M143.88 374.5q1.29.19 1.5.91.14.46-.23.77-.95.81-.89 2.34c.13 3.62-4.36 5.96-7.13 7.46-6.65 3.58-15.51 2.53-22.81 3.27-2.92.3-8.48-.62-10.85 1.28q-.36.3-.83.26c-3.75-.27-7.4.56-10.9.35-7.97-.48-16.4.62-24.16-.71q-6.41-1.1-12.91.09a1.8 1.72 48.4 0 1-.97-.08c-2.73-1.01-6.19-.62-8.37-.8-6.36-.53-12.33 2.34-18.4-.78q-.5-.25.02-.47l1.53-.67q.36-.15.15-.49l-.16-.25q.55-.14 1.02-.56-.19 1.43 1.26 1.33c13.84-.92 31.26-3.29 46.72-4.47q27.56-2.12 54.85-4.84a.55.55 0 0 0 .12-1.06l-.98-.33c1.46-1.69-.66-3.69 1-4.53a.62.61-15.3 0 1 .9.51l.2 3.52a.61.61 0 0 0 .52.57q5.93.83 9.8-2.62z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#705c56",
    d: "m144.25 374.58 7.65.12 11.35 3.69L224 397.81a.91.91 0 0 1 .63.85l.06 6.62a1.07 1.07 0 0 1-.89 1.07l-3.8.66-2.01.2q-101.37 11.5-155.68 17.85-3.25.38-5.69.06L3.64 396.55q-3.26-1.37-1.88-8.2a.96.96 0 0 1 .85-.77l10.97-1.13a1.07 1.07 0 0 0 .96-1.1l-.29-9.85c1.33-1.52 1.87 7.73 1.87 7.78q.26 2.79 1.42 4.3a.93.92-21.5 0 0 .82.35l10.11-.95.16.25q.21.34-.15.49l-1.53.67q-.52.22-.02.47c6.07 3.12 12.04.25 18.4.78 2.18.18 5.64-.21 8.37.8a1.8 1.72 48.4 0 0 .97.08q6.5-1.19 12.91-.09c7.76 1.33 16.19.23 24.16.71 3.5.21 7.15-.62 10.9-.35q.47.04.83-.26c2.37-1.9 7.93-.98 10.85-1.28 7.3-.74 16.16.31 22.81-3.27 2.77-1.5 7.26-3.84 7.13-7.46q-.06-1.53.89-2.34.37-.31.23-.77-.21-.72-1.5-.91.18.04.37.08zm2.64 38.42h.63q.87 0 .15-.49-1.2-.81-2.71-.47-.46.1-.84.4-1.33 1.05-2.34-.27a.35.34 63.9 0 1 .18-.54l3.02-.81a.25.25 0 0 0 .02-.48q-.11-.05-.24-.08-.13-.02-.07-.14l.94-1.73a.85.84 9.7 0 1 .63-.44l5.81-.8a.81.81 0 0 0 .17-1.56q-1.32-.48-3.09-.03c-4.43 1.12-9.58 1.22-12.99 1.6q-21.12 2.33-42.24 4.58c-9.3.99-23.81 3.2-35.84 4.02q-.52.04-.96-.24-6.97-4.35-14.51-7.55-.23-.1-.31-.34l-.13-.36q-.09-.28-.39-.32c-2.27-.27-3.71-1.58-5.28-2.37q-11.35-5.75-22.71-11.49c-1.33-.68-3.04-2-4.97-2.29a.92.92 0 0 0-.48 1.77q.84.34 1.65.42.5.05.99.14 1.01.19 1.04.69.02.46.44.69 15.52 8.42 41.85 21.44 3.9 1.93 1.94 6.49-.24.56.23.94c1.66 1.34 4.19.37 5.77.21q26.17-2.66 52.28-5.85 12.25-1.49 24.51-3.01c2.28-.28 4.99-1.41 7.8-1.29a.07.07 0 0 0 .07-.09l-.09-.25q-.03-.1.07-.1z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a2f2d",
    d: "m131.46 377.05.98.33a.55.55 0 0 1-.12 1.06q-27.29 2.72-54.85 4.84c-15.46 1.18-32.88 3.55-46.72 4.47q-1.45.1-1.26-1.33l101.97-9.37z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#826a63",
    d: "m146.82 413.1.09.25a.07.07 0 0 1-.07.09c-2.81-.12-5.52 1.01-7.8 1.29q-12.26 1.52-24.51 3.01-26.11 3.19-52.28 5.85c-1.58.16-4.11 1.13-5.77-.21q-.47-.38-.23-.94 1.96-4.56-1.94-6.49-26.33-13.02-41.85-21.44-.42-.23-.44-.69-.03-.5-1.04-.69-.49-.09-.99-.14-.81-.08-1.65-.42a.92.92 0 0 1 .48-1.77c1.93.29 3.64 1.61 4.97 2.29q11.36 5.74 22.71 11.49c1.57.79 3.01 2.1 5.28 2.37q.3.04.39.32l.13.36q.08.24.31.34 7.54 3.2 14.51 7.55.44.28.96.24c12.03-.82 26.54-3.03 35.84-4.02q21.12-2.25 42.24-4.58c3.41-.38 8.56-.48 12.99-1.6q1.77-.45 3.09.03a.81.81 0 0 1-.17 1.56l-5.81.8a.85.84 9.7 0 0-.63.44l-.94 1.73q-.06.12.07.14.13.03.24.08a.25.25 0 0 1-.02.48l-3.02.81a.35.34 63.9 0 0-.18.54q1.01 1.32 2.34.27.38-.3.84-.4 1.51-.34 2.71.47.72.49-.15.49h-.63q-.1 0-.07.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d4cf",
    d: "m3.64 396.55 52.98 28.57q.93.7 1.27 2.14.12.5.62.64 1.02.29 2.27-.03c-3.91 1.4-6.47.82-9.59-2-3.17-2.87-7.3-4.84-11.03-7.19q-.42-.26-.9-.19-2.82.45-3.74-2.19-.18-.51-.68-.73c-2.53-1.1-4.83-2.47-7.47-3.31-2.11-.68-4.1-2.32-5.91-3.08q-4.71-1.97-8.89-4.89c-2.35-1.64-5.29-1.81-7.96-2.74l-.97-5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M4.61 401.55c2.67.93 5.61 1.1 7.96 2.74q4.18 2.92 8.89 4.89c1.81.76 3.8 2.4 5.91 3.08 2.64.84 4.94 2.21 7.47 3.31q.5.22.68.73.92 2.64 3.74 2.19.48-.07.9.19c3.73 2.35 7.86 4.32 11.03 7.19 3.12 2.82 5.68 3.4 9.59 2q8.15-.72 16.44-1.81c3.21-.42 6.51-.45 9.65-1.13 2.62-.58 5.06-.2 7.69-.76 3.57-.75 6.81-.68 10.17-1.6a1.15 1.13-35.2 0 1 .94.15c.93.63 1.2.64 2.35.39q8.16-1.75 16.47-2.32c4.59-.32 9.94-1.44 15.05-1.41q.47.01.69-.4c.05-.09 30.35-3.86 32.99-4.31 2.71-.46 5.4.05 8.27-.43 5.95-.99 11.53-1.27 17.25-2.28q8.84-1.55 11.51-1.45 4.45.17 7.27-1.25.46-.24.46-.76l.01-1.29 2.01-.2q.01 1.99.85 3.55.22.41.66.57 1.54.57 2.07 2.15a.17.17 0 0 0 .33 0q.05-.17.11-.34.06-.18.25-.17 2.91.14 5.34 1.77.43.29.54.8c1.02 4.69-6.58 6.55-9.67 5.52-3.9-1.3-7.68-.66-11.37 1q-.42.19-.88.17c-1.81-.09-2.96 1.03-4.51 1.22-1.91.23-3.94.06-5.7.28q-11.4 1.4-22.89 1.71c-2.35.06-4.13 1.22-6.29 1.16q-4.55-.12-8.85 1.36a1.44 1.42-43.9 0 1-.97-.01q-2.36-.89-4.19.57-.4.33-.92.39-2.55.31-4.89-.73-.48-.21-.98-.09-3.77.94-7.01.91-2.21-.02-3.03 1.75-.21.46-.68.6c-1.22.38-8.13 1.63-9.23.35q-.27-.32-.68-.39-4.55-.77-8.66 1.07a1.37 1.32-47.6 0 1-.95.06c-3.77-1.15-5.67.57-8.93.46q-1.82-.06-3.65-.24-.43-.04-.82.15-1.42.71-2.88.28-.44-.13-.89-.03l-3.92.84q-.58.13-.61-.47c-.2-3.67-10.02-1.94-11.86-1.24-2.8 1.07-4.39.88-7.02.18a1.47 1.47 0 0 0-.97.08c-3.07 1.42-4.64.74-7.72.65-1.8-.06-10.43-.74-9.48 2.78a1.24 1.24 0 0 1-1.02 1.54q-2.48.36-4.1-1.39a2.05 1.97 75.3 0 0-.9-.55l-1.72-.47q-.44-.12-.75-.45-.73-.78-2.87-2.05-18.84-11.2-38.14-21.59-.92-.5-3.88-2.67-.41-.3-.46-.81l-.6-5.69zm216.82 14.05a1.15 1.15 0 0 0 1.65-1.58l-1.74-2.32a.7.7 0 0 0-1.26.38q-.11 2.32 1.35 3.52z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#cec8c2",
    d: "m217.99 407.21-.01 1.29q0 .52-.46.76-2.82 1.42-7.27 1.25-2.67-.1-11.51 1.45c-5.72 1.01-11.3 1.29-17.25 2.28-2.87.48-5.56-.03-8.27.43-2.64.45-32.94 4.22-32.99 4.31q-.22.41-.69.4c-5.11-.03-10.46 1.09-15.05 1.41q-8.31.57-16.47 2.32c-1.15.25-1.42.24-2.35-.39a1.15 1.13-35.2 0 0-.94-.15c-3.36.92-6.6.85-10.17 1.6-2.63.56-5.07.18-7.69.76-3.14.68-6.44.71-9.65 1.13q-8.29 1.09-16.44 1.81-1.25.32-2.27.03-.5-.14-.62-.64-.34-1.44-1.27-2.14 2.44.32 5.69-.06 54.31-6.35 155.68-17.85z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4c8c1",
    d: "M221.43 415.6q-1.46-1.2-1.35-3.52a.7.7 0 0 1 1.26-.38l1.74 2.32a1.15 1.15 0 0 1-1.65 1.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailers);
export default __webpack_public_path__ + "static/media/retailers.79e9afebd1a312cc6b676f5a12e70bcb.svg";
export { ForwardRef as ReactComponent };